export default {
  language: 'English',
  switchlangtip: 'Language switched successfully',
  nav: {
    // app.vue左侧导航栏
    singeltest: 'Demo',
    ai_call: 'AI Calling',
    calling_operation: 'Calling Operation',
    robot: 'Robot Management',
    black_list: 'Black List',
    robot_list: 'Robot List',
    add_call: 'Add Call',
    systemsettings: 'System Settings',
    accountmanagement: 'Account Management',
    corporateaccountinformation: 'Company Account Info.',
    usermanagement: 'User Management',
    functionrightsrole: 'Role Management',
    dashboard: 'Dashboard',
    promote: 'Promote',
    callcenter: 'Call Center',
    executecall: 'Tasks',
    detailsofcall: 'Call History',
    reportstatistics: 'Report Statistics',
    overallreportstatistics: 'Overall Report Statistics',
    speechreportstatistics: 'Speech Report Statistics',
    accountreportstatistics: 'Account Report Statistics',
    robotreportstatistics: 'Robot Report Statistics',
    archivingcenter: 'Archiving Center',
    historicaltaskrecord: 'Historical Task Record',
    historicalcalllog: 'Historical Call Log',
    detailsofcharges: 'Details Of Charges',
    testcall: 'Tests',
    guide: 'Guide',
    strategy: 'Strategy',
    plan: 'Plan',
    auditInformation: 'IC Task',
    PDetails: 'PDetails',
    PStrategy: 'PStrategy',
    PPlans: 'PPlans',
    ICDetail: '信审详情',
    ICStrategy: '信审呼叫策略',
    ICPlan: '信审计划任务',
    accessControl: 'Access Control'
  },
  global: {
    date: 'Please select date',
    taskNameSelector: {
      selectLabel: 'Tasks',
      selectTask: 'Please Select Task Name',
      selectTest: 'Please Select Test Name',
      allSelect: 'All Selected',
      selectWarn: 'Please select at least one task name'
    },
    planNameSelector: {
      selectLabel: 'Plans',
      selectTask: 'Please Select Plan Name',
      selectTest: 'Please Select Test Name',
      allSelect: 'All Selected',
      selectWarn: 'Please select at least one plan name'
    },
    distinctSelector: {
      label: 'Distinct',
      placeholder: 'Please Select Distinct'
    },
    select: 'Select',
    // filter: 'Filter',
    MarketingA: 'A: Interested in',
    MarketingB: 'B: Not interested in',
    query: 'Search',
    filter: 'Filter',
    today: 'Today',
    yesterday: 'Yesterday',
    nearly_three_day: 'Last 3 days',
    nearly_seven_day: 'Last 7 days',
    nearly_thirty_day: 'Last 30 days',
    nearly_days: 'Last {num} days',
    startTime: 'Start Date',
    endTime: 'End Date',
    batchDel: 'Batch Delete',
    telNumber: 'Phone Number',
    triggerTime: 'Trigger Time',
    intention: 'Intentions',
    sort: 'Sorting',
    setSort: 'Change Sorting',
    showName: 'Name Display',
    totals: 'Total Count',
    rounds: 'Round(s)',
    splitStr: ' ',
    vs: 'vs.',
    processStatus: 'Processing Status',
    pending: 'Pending',
    processing: 'In Progress',
    finished: 'Completed',
    toSelect: 'Select',
    editSelect: 'Change Selection',
    other: 'Others'
  },
  menuNode: {
    CallTasks: 'Tasks',
    CallPlans: 'Plan',
    CallStrategy: 'Strategy',
    CallDetails: 'Call History',
    ICDetail: 'IC Detail',
    BlackList: 'Black List',
    RobotList: 'Robot List',
    SingleTest: 'Demo',
    AddCall: 'Add Call',
    Corporate: 'Company Account Info.',
    UserControl: 'User Management',
    accountSafe: 'Account Security Management',
    RolePermission: 'Role Management',
    Dashboard: 'Dashboard',
    AiCalling: 'AI Calling',
    RobotManage: 'Robot Management',
    CallingOperation: 'Calling Operation',
    Inbound: 'Inbound',
    AccountManage: 'Account Management',
    personalInfo: 'Account Information',
    systemsettings: 'System Settings',
    collection: 'Collection',
    marketing: 'Telemarketing',
    info_check: 'Info Check',
    outbound: 'Calling Module',
    operationOutbound: 'Calling Operation',
    pack_up_menu: 'Collapse Menu',
    switch_old_version: 'Switch to Old Version',
    switch_new_version: 'Switch to New Version',
    prompt_cannot_used: "Your account is created in the new version. You can't use the old version",
    personalSetting: 'Personal Settings',
    loginInfo: 'Login Information',
    template: 'Experience Version',
    RobotExperience: 'Experience a robot',
    servise_tools: 'Services and Tools',
    helpCenter: 'Help Center',
    OperatingRecord: 'Operation Records',
    CallAssistant: 'Calling Assistant',
    releaseNotes: 'Version Records',
    cod: 'E-commerce',
    WorkflowManger: 'Workflow Management',
    WorkflowTemplate: 'Workflow Template',
    Workflow: 'Workflow Tasks',
    SmsTemplate: 'SMS Template Management',
    WhatsappTemplate: 'WhatsApp Template Management',
    MultiChannelManager: 'Multi-Channel Management',
    StageReport: 'Periodic Report',
    CrossLogin: 'Impersonate',
    manual: 'Operating Manual',
    document: 'API Documents',
    add: 'Add',
    info: 'View Details',
    copy: 'Copy',
    edit: 'Edit',
    child: 'View Subtasks',
    check: 'Check Progress',
    view: 'Data Overview',
    editRole: 'Edit Role',
    addRole: 'Add a New Role',
    version: 'Version Management',
    batchShare: 'Share',
    shareLog: 'Share History',
    viewData: 'View Data',
    Application: 'App Market',
    view_number: 'Plaintext Phone Numbers',
    CallDetailAudioDownload: 'Download Recordings in Details page',
    TaskDetailAudioDownload: 'Download Recordings in Tasks page',
    PlanViewAudioDownload: 'Download Recordings in Plan page',
    ViewCallDetail: 'View Dialogues',
    Tools: 'Services and Tools',
    WorkflowVersion: 'Version Management',
    CallLog: 'Call History',
    chatbot: 'Chatbot',
    ChatbotOverview: 'Overview',
    ChatbotLiveMonitor: 'Live Monitor',
    ChatbotAnalysis: 'Bot analysis',
    ChatbotCR: 'Conversation Records',
    ChatbotSocial: 'Message Channel',
    ChatbotManage: 'Chatbot Management',
    ChatbotOnline: 'Release Chatbot',
    ChatbotReq: 'Request',
    ChatbotWBTmpl: 'WA Template Management',
    ChatbotWBTmplDetail: 'Template Details',
    ChatbotWBTmplAdd: 'New Template',
    ChatbotWBTmplEdit: 'Edit Template',
    ChatbotChat: 'Chat',
    ChatbotTeamInbox: 'Team Inbox',
    ChatbotMAB: 'Marketing Broadcast',
    ChatbotBroadcast: 'Broadcast List',
    ChatbotGeneral: 'General',
    ChatbotAPI: 'API Doc',
    ChatbotOptOut: 'Opt-out List',
    InboundRobotManage: 'Robot Management',
    InboundDashboard: 'Dashboard',
    InboundCallRecords: 'Call History',
    timeTip: 'Online data queries restricted to the most recent 6 months only.',
    timeTip2: 'Only support online queries for the most recent 6 months of data starting from March 1, 2024.',
    workflowTip: 'This method only supports queries generated after February 1, 2024',
    configCenter: 'Configuration Center',
    accessControl: 'Access Control',
    webhook: 'Callback Configurations',
    holiday: 'Calendar Management',
    Insights: 'Insights',
    ChatbotInsights: 'Insights',
    ChatbotInsightsLiveMonitor: 'Live Monitor',
    ChatbotInsightsRecord: 'Historical Dashboard',
    ChatbotHistorical: 'Historical Dashboard'
  },
  account: {
    // 账户管理
    account_time_zone_new: 'Account Region and Time Zone',
    cod: 'E-commerce',
    template: 'Experience Version',
    administrator: 'Administrator',
    enterprise: 'Affiliate Company',
    account_title: 'Account Name',
    account_country: 'Country',
    account_time_zone: 'Time Zone',
    account_id: 'Account ID',
    corporate_contacts: 'Corporate Contact Person',
    contact: 'Contact Name',
    email: 'Email',
    phone: 'Mobile Number',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    user_group: 'User Group',
    add_uer: 'Add a User',
    edit_uer: 'Edit the User',
    edit_group: 'Edit Group',
    add_group: 'Add a New Group',
    group_name: 'Group Name',
    user_name: 'Name',
    first_name: 'First name',
    last_name: 'Last name',
    account_number: 'Login Account',
    password: 'Password',
    initial_password: 'Initial password',
    roleId: 'Role ID',
    lastLoginTime: 'Last Login Time',
    group: 'Group Name',
    role: 'Role Name',
    edit: 'Edit',
    added: 'Add',
    enable: 'Activate',
    disable: 'Deactivate',
    save: 'Save',
    reset_passwords: 'Reset Password',
    new_login_password: 'New password',
    set_new_login_password: 'Change Password',
    error_user_tip: 'A risk has been detected in your account. For the security of your account, please change your login password.',
    new_user_tip: 'For the security of your account, please change your login password.',
    confirm_password: 'Confirm Password',
    add_role: 'Add a New Role',
    edit_role: 'Edit Role',
    role_name: 'Role Name',
    role_describe: 'Role Description',
    actions: 'Operation',
    status: 'Status',
    delete: 'Delete',
    basic_information: 'Basic Information',
    business_type: 'Business Type',
    data_permission: 'Data Permissions',
    fnction_permissions: 'Function permissions',
    collection: 'Collection',
    marketing: 'Marketing',
    info_check: 'Info Check',
    CallingOperation: 'Calling Operation',
    chatbot: 'Chatbot',
    select_all: 'Select All',
    clear: 'Clear',
    all: 'All',
    prompt_account_name: 'Enter account and name',
    prompt_password_again: 'Please re-enter your password',
    prompt_role_description: 'Please enter a role description',
    prompt_first_name: 'Please enter name',
    prompt_last_name: 'Please enter the last name',
    prompt_login: 'Please enter login account',
    prompt_password: '8-16 digits, uppercase and lowercase letters',
    prompt_logo: 'Pictures can be uploaded in jpg/jpeg/png/gif format, with the size smaller than 5M',
    prompt_group: 'Please select a group',
    prompt_role: 'Please choose a role',
    prompt_role_name: 'Please enter role name',
    prompt_delete_role: 'The role is already associated with users and cannot be deleted',
    error_logo_type: 'Only jpg/jpeg、png、gif formats can be uploaded',
    error_logo_size: 'LOGO size cannot exceed 5M',
    error_cannot_exceed_200: 'Cannot exceed 200 characters',
    error_cannot_exceed_100: 'Cannot exceed 100 characters',
    error_cannot_exceed_50: 'Cannot exceed 50 characters',
    error_cannot_exceed_20: 'Cannot exceed 20 characters',
    error_group: 'There are users in this group and cannot be deleted',
    error_group_size: 'Not more than 50 groups',
    error_login: 'The login account is required to have a value',
    error_login_exis: 'The account name already exists',
    error_password: 'The password must be 8-16 digits and include numbers, uppercase and lowercase letters',
    error_password_different: 'Passwords do not match',
    error_group_name: 'Group name cannot be repeated',
    error_enable: 'The number of enabled users cannot exceed {xxx}',
    error_role_name: 'The role name is required to have a value',
    error_business_type: 'The business type is required to have a value',
    error_first_name: 'The first name is required to have a value',
    error_last_name: 'The last name is required to have a value',
    error_enter_group_name: "Group Name can't be empty",
    error_new_login_password: 'Please enter the new login password ',
    error_confirm_password: 'Please enter the confirm password',
    permission_list: {
      view: 'View',
      add: 'Add',
      edit: 'Edit',
      start: 'Start',
      delete: 'Delete',
      pause: 'Pause/Resume',
      cancel: 'Cancel',
      download: 'Download',
      copy: 'Copy',
      enable: 'Activate',
      disable: 'Deactivate',
      ableOrNot: 'Deactivate/Activate',
      viewShield: 'Check Blocked Data',
      allocation: 'Assign',
      download_task: 'Download task',
      download_roll: 'Download callee numbers',
      download_detail: 'Download details',
      password: 'Reset Password',
      apply: 'Apply',
      edit_remark: 'Edit Remarks',
      edit_name: 'Modify Template Name',
      download_subtask: 'Download Subtask Records',
      view_subtask_detail: 'View Subtask Details',
      view_subtask: 'View Subtasks',
      add_detail: 'Add a List',
      workflowProgress: 'Check Progress',
      triggerImmediately: 'Trigger Immediately',
      categorize: 'Categorize Event Labels',
      RobotExperience: 'Experience a robot',
      StageReport: 'Periodic Report',
      CrossLogin: 'Impersonate',
      MultiChannelManager: 'Multi-Channel Management',
      releaseNotes: 'Version Records',
      operateWord: 'Operating Manual',
      apiWord: 'API Documents',
      OperatingRecord: 'Operation Records',
      Application: 'App Market',
      view_number: 'Nomor Telepon dalam Teks Biasa',
      selectCountry: 'Select Country',
      processProportion: 'Bot Process Distribution',
      labelDistribution: 'Intention Distribution',
      transRateTrends: 'Call & Transfer Spread',
      transCauseDistribution: 'Reason Distribution for Agent Transfer',
      effectKnowledge: 'Percentage of Valid Knowledge',
      knowledgeHitRatio: 'Knowledge Hit Rate',
      hotKnowledge: 'Top10 Popular Knowledge',
      unpopularKnowledge: 'Top20 Least Popular Knowledge',
      callDimension: 'Call Overview',
      robotCalls: 'Total Calls',
      robotCallsProgress: 'Robot Calls in Progress',
      successfulTransferRate: 'Successful Transfer Rate',
      arCallDuration: 'Average Robot Call Duration',
      arInteractionRounds: 'Average Robot Interaction Rounds',
      agentCalls: 'Agent Calls',
      agentCallsProgress: 'Agent Calls in Progress',
      aTransferRate: 'Attempted Transfer Rate',
      taCallDuration: 'Total Average Call Duration',
      knowledgeDimension: 'Knowledge Points',
      downRecording: 'Download Recordings',
      downRecord: 'Download Records',
      approvalAddTask: 'Approval - New Task ',
      approvalDownloadList: 'Approval - Download List',
      approvalApprove: 'Approval - Approve',
      approvalAddPlan: 'Approve - New Plan ',
      approvalDownloadPlanList: 'Approval - Download List',
      approvalPlanApprove: 'Approval - Approve',
      ViewCallDetail: 'View Dialogues',
      Dashboard: 'Dashboard',
      AccountManage: 'Account Management',
      ModifyTimeZone: 'Modify Time Zone',
      Corporate: 'Company Account Info.',
      RolePermission: 'Role Management',
      AiCalling: 'AI Calling',
      CallTasks: 'Call Task',
      CallPlans: 'Call Plan',
      CallStrategy: 'Call Strategy',
      CallDetails: 'Call History',
      transferOrNot: 'Transferred to Agent or Not',
      BlackList: 'Black List',
      CallAssistant: 'Calling Assistant',
      addMessage: 'New Hang-up SMS',
      deleteMessage: 'Delete Hang-up SMS',
      editMessage: 'Edit Hang-up SMS',
      messageStatus: 'Hang-up Status',
      viewHangUpMessage: 'Hang-up Details ',
      WorkflowDashboard: 'Updated Contacts',
      WorkflowDashboardPage: 'Workflow Dashboard',
      uploadList: 'Number of Contacts Uploaded',
      singularName: 'Unique Contacts',
      numberDelisting: 'Cancelled Contacts',
      numberWorkflowTasks: 'Workflow Tasks Created',
      workflowTasksExecution: 'Ongoing Workflow Tasks ',
      uploadListNumberTrend: 'Trend of Contacts Uploaded',
      callsInList: 'Total Contacts Dialed',
      redialListNumber: 'Unique Contacts Dialed',
      numberDeconnecting: 'Number of Unique Contacts Reached',
      disconnectionRate: 'Unique Connection Rate',
      totalNumberCalls: 'Dialed Calls',
      totalNumberRounds: 'Connected Calls',
      totalConnectionRate: 'Total Connection Rate',
      AverageConnectedCalls: 'Average Dials',
      averageNumberCalls: 'Average Call Attempts',
      onAverageNumberCalls: 'Average Attempts Per Connected Call',
      averageCallDuration: 'Average Call Duration',
      averageInteractiveRounds: 'Average Number of Interaction Rounds',
      averageRingingDuration: 'Average Ringing Duration',
      tryTurnLaborNumber: 'Attempts to transfer to agents',
      attemptAgentNum: 'Attempts to transfer to agents',
      attemptTransferLaborRate: 'Attempted Transfer Rate',
      numberSuccessfulTransfers: 'Number of Successful Transfers',
      successRateTransfer: 'Transfer Successful Rate',
      robotSearch: 'Robot Búsqueda',
      platformSearch: 'Search by Platform',
      downloadData: 'Download',
      trendNumberCallsList: 'Trends of number of Contacts Dialed',
      labelDistributionTrend: 'Trend of Intention Distribution',
      connectionRateTrend: 'Connection Rate Trend',
      callDurationDistribution: 'Call Duration Distribution',
      callDurationDistributionTrend: 'Trend of Call Duration Distribution',
      ringClassification: 'Ring Type',
      hangUpSort: 'Hangup Type',
      trendLaborTransferRate: 'Transfer Rate Trend',
      outboundCall: 'Outbound call',
      sms: 'sms',
      waMessage: 'WA Message',
      pds: 'PDS',
      waTemplate: 'WA Template',
      shortMessagesSent: 'Total SMS Sent Contacts',
      smsSingularName: 'De-duplicated Contacts sent by SMS',
      goTo7DayHits: 'Clicked in 7 days after deduplication',
      goClickThroughRate: 'De-duplicated Click-through Rate',
      totalNumberTransmissions: 'Total Sent',
      total7DayHits: 'Total 7-day Clicked',
      clickRate: 'Click-through Rate',
      averageNumberTransmissions: 'Average Number of Sends',
      trendNumberShortMessage: 'Trend of Contacts Sent SMS',
      clickRateTrend: 'Click-through Rate Trend',
      waSmsSingularName: 'WA De-duplicated Contacts sent by SMS',
      waGoTo7DayHits: 'WA Clicked in 7 days after deduplication',
      waGoClickThroughRate: 'WA De-duplicated Click-through Rate',
      waTotalNumberTransmissions: 'WA Total Sent',
      waTotal7DayHits: 'WA Total 7-day Clicked',
      waClickRate: 'WA Click-through Rate',
      waAverageNumberTransmissions: 'WA Average Number of Sends',
      waTrendNumberShortMessage: 'WA Trend of Contacts Sent SMS',
      waClickRateTrend: 'WA Click-through Rate Trend',
      waShortMessagesSent: 'WA Total SMS Sent Contacts',
      numberPdsList: 'PDS Contacts',
      pdsSingularName: 'Number of PDS Unique Contacts',
      trendPdsListNumber: 'PDS Contacts Trend',
      waTemplateTotalNumber: 'Total number of Contacts sent WA Template',
      waTemplateSingularName: 'Number of de-duplicated Contacts sent WA Template',
      wtTotalNumberTransmissions: 'WT Total Sent',
      wtAverageNumberTransmissions: 'WT Average Number of Sends',
      waTemplateIndicates: 'Trends in the number of WA Template sent Contacts',
      sendNumberTrend: 'Trend in Number of Sends',
      deliveryNumber: 'Number of SMS Delivered',
      successTransmissions: 'Number of Successfully Sent SMS',
      successResending: 'Successful unique deliveries',
      waDeliveryNumber: 'WA Messages Successfully Delivered',
      waSuccessTransmissions: 'WA Successfully sent messages ',
      waSuccessResending: 'WA Successful unique deliveries',
      custom_components: 'Custom Components',
      holiday: 'holiday',
      viewDashboard: 'Data Overview',
      WorkflowVersion: 'WorkflowVersion',
      archive_rows: 'View Version List',
      WorkflowComponents: 'Workflow Components',
      time: 'time',
      manual: 'manual',
      slot: 'slot',
      user_latest_intention: 'user_latest_intention',
      customized_attributes: 'customized_attributes',
      splitter: 'splitter',
      url_click: 'url_click',
      combination: 'combination',
      voicebot_call: 'voicebot_call',
      voicebot_agent_call: 'voicebot_agent_call',
      pds_call: 'pds_call',
      wa_message: 'wa_message',
      api: 'api',
      voicebot_kit: 'voicebot_kit',
      mail: 'mail',
      PDSConfig: 'PDS Configurations',
      voicemail: 'Voicemail',
      qa: 'QA Button',
      contactNumberInterval: 'Contact Number Interval',
      create: 'Add',
      status: 'Status',
      Tools: 'Services and Tools',
      personalSetting: 'Personal Settings',
      personalInfo: 'Account Information',
      avatar: 'Modify Photo Icon',
      email: 'Change Email Address',
      loginInfo: 'login Information',
      '2FA': '2FA',
      viewNumber: 'View Plaintext',
      MingWenDownload: 'Download Plaintext',
      timeZone: 'Modify Time Zone',
      contact: 'Enterprise Contacts Display',
      approvalBack: 'Approve - Withdraw',
      approvalPlanBack: 'Approve - Withdraw',
      ringSorts: 'Ring Type',
      updateListNumber: 'Updated Contacts',
      accessControl: 'Access Control',
      BusinessInsight: 'Business Insights',
      webhookPage: 'Callback Configurations',
      callbackEvent: 'Event Callback ',
      encryptionPolicy: 'Event Callback ',
      intelligentOutbound: 'Intelligent Outbound Call',
      intelligentInbound: 'Intelligent Inbound Call',
      addCallbackEvent: 'New Event Callback',
      simuCallback: 'Simulate Callback',
      Customer: 'Client Management',
      downloadBlock: 'Download Blocked Data',
      delBlock: 'Delete Blocked Data',
      customSet: 'Custom Settings',
      validCallToal: 'Effective Connected Calls',
      validRepeatToal: 'De-duped Effective Connections',
      validCallRate: 'Effective Connection Rate',
      validRepeatRate: 'De-duped Effective Connection Rate',
      mainCallDayFB: 'Daily Main Call Volume',
      pdsReasonDayFB: 'Daily Transfer Reasons',
      robotLabelDayFB: 'Daily Intention Distribution',
      newUserNum: 'New Contacts',
      oldUserNum: 'Existing Contacts',
      orderCreateDayFB: 'Daily Ticket Type',
      xjqsOrderDayFB: 'Daily Fake Receipts',
      validCallDes: 'Effective Call Distribution',
      hangTypeDes: 'Hangup Type Distribution',
      avgCallTimeDes: 'Avg Call Duration Distribution',
      satisScoreDis: 'Bot Rating and Satisfaction Rate',
      usersDayFB: 'Daily Distribution of Contacts',
      agentAvgDuration: 'Avg Agent Call Duration',
      falseSign: 'Fake Receipts',
      robotPerf: 'Bot Performance',
      userStats: 'Contact Statistics',
      businessView: 'Business Insights',
      transSuccessRate: 'Success Rate of Transferring to Agent',
      robotEvalRate: 'Bot Evaluation Rate',
      robotSatisAvgScore: 'Average Bot Satisfaction Score',
      validCallNum: 'Effective Call Volume',
      callerNum: 'Incoming Contacts',
      validUser: 'Active Contacts',
      repeatCallRate: 'Repeat Call Rate',
      robotOneTime: 'Bot First Contact Resolution Rate',
      robotOneTimeChart: 'Bot First Contact Resolution Rate Echart',
      maxCurTrend: 'Daily Peak Concurrency',
      dataExport: 'Data Export',
      intentAccuracy: 'Intent Accuracy Rate',
      feedback: 'Exception Feedback'
    },
    disabled: 'Deactivated',
    enabled: 'Activated',
    user_table: 'User List',
    role_table: 'Role List',
    Inbound: 'Inbound',
    resMust: 'Please select at least one permission.'
  },
  dashboard: {
    // dashboard界面
    noData: 'No Data',
    // overview: 'Overview',
    overviewDescription: 'This mainly shows the statistical results of the dialing tasks.',
    totalNumOfCalls: 'Total Callee Number',
    durationOfCall: 'Total Duration (s)',
    avDurationOfCalls: 'Average Call Duration',
    reachedNum: 'Number of Connected Calls',
    totalCost: 'Total Costs',
    averageCost: 'Average Cost per Call',
    reachedRateOfCall: 'Reached Call Rate',
    // intentions of customers
    customerIntention: 'Customers Intentions',
    customerIntention_distinct: 'Customers Intentions (Distinct)',
    reachedRate_distinct: 'Connection Rate (Distinct)',
    total_customer_distinct: 'Total Customers',
    total_reached_distinct: 'Reached Customers',
    // duration of calls
    durationOfCalls: 'Duration of Calls',
    callLength: 'Call Duration',
    number: 'Number',
    // duration: 'Duration(s)',
    overallResult: 'Info Check Results',
    comingSoon: 'More functions will be coming soon.',
    // dashboard 底部table
    table: {
      taskName: 'Task Name',
      totalCost: 'Total Costs($)',
      total: 'Total Callee Number',
      unreached: 'Unreached',
      reached: 'Reached',
      successRate: 'Connection Rate',
      totalDuration: 'Total Duration (s)',
      average: 'Average Call Duration (s)',
      intention: 'Intention'
    },
    viewDataTip: 'Please contact your customer manager for more data',
    plans: 'Number of Plans',
    tasks: 'Number of Tasks',
    calling_tasks: 'Calling Task',
    pending_tasks: 'Pending Tasks',
    total_callee: 'Total Phone Number',
    reached_rate: 'Connection Rate',
    average_call_duration: 'Average Call Duration',
    average_call_waiting_duration: 'Average Ring Time ',
    today: 'Today',
    last_three_day: 'Last 3 days',
    last_seven_day: 'Last 7 days',
    overview: 'Data Overview',
    call_analysis: 'Call Analysis',
    vdoing: 'Filter',
    khyxzb: 'Customer Intentions',
    xsjgfb: 'IC Result Distribution',
    callTime: 'Call Duration',
    ringType: 'Ring Type',
    nocallType: 'Hang-up Type',
    callTrend: 'Connection Rate Trend',
    byHour: 'By Hour',
    byDay: 'By Day',
    allTrend: 'Customer Intention Trend',
    icResult: 'IC Results Trend',
    duration: 'Average Call Duration',
    average_time: 'Average Ring Time',
    tasklist: 'Task List',
    total_types: 'All Types',
    all: 'All',
    all_task: 'All Tasks',
    all_robot: 'All Robots',
    all_results: 'All Results',
    all_trends: 'All Intentions',
    shuliang: 'Number',
    shichang: 'Duration (s)',
    unduplicated: 'Unique',
    duplicate: 'Total',
    totalTrend: 'Total Number of Results',
    everyCallTime: 'Daily Call Duration',
    totalNumber: 'Total Phone Number',
    totalCallNumber: 'Total Reached Number',
    totalCallRate: 'Total Connection Rate',
    noConnectedNumber: 'Unreached Number',
    tocallNumber: 'Total Number of Calls',
    max_day_data: 'Maximum of 31 days can be selected',
    by_task: 'by Task',
    by_robot: 'by Robot',
    plans_tooltip: 'Total number of plans with start time within selected range',
    taks_tooltip: 'Total number of tasks with start time within selected range',
    calling_tasks_tooltip: 'Total number of tasks in execution within selected time range',
    pending_tasks_tooltip: 'Total number of tasks on waiting list within selected time range',
    total_callee_tooltip: 'Total number under the filtered conditions',
    reached_rate_tooltip: 'Reached rate under the filtered conditions',
    average_call_duration_tooltip: 'Average call durations under the filtered conditions',
    average_call_waiting_duration_tooltip: 'Average waiting time under the filtered conditions',
    khyxzb_hover_explain: '(1) Proportion of total intentions under the filtered conditions. \n (2) Distinct by phone number',
    callTime_hover_explain: 'Proportion of the average call durations under the filtered conditions',
    ringType_hover_explain: 'Proportion of the ring type under the filtered conditions',
    nocallType_hover_explain: 'Proportion of the hang-up type under the filtered conditions',
    call_tip_filter_rule: '(1) Daily reached Calls rate under the filtered conditions.\n(2) Distinct by phone number.',
    trend_tip: 'Daily proportion of intentions under the filtered conditions',
    duration_tip: 'Daily average call durations under the filtered conditions',
    average_time_tip: 'Daily average waiting time under the filtered conditions',
    tasklist_tip: 'The calling result of each task under the filtered conditions',
    connect_number_tooltip: 'Number of all reached calls under the filtered conditions',
    all_talk_time_tooltip: 'Total call durations under the filtered conditions',
    connect_number: 'Total Reached Number',
    all_talk_time: 'Total Duration',
    dimension: 'Deduplicate Conditions'
  },
  workbenchtable: {
    total: 'Total Calls',
    unreached: 'Total Unreached Calls',
    reached: 'Reached Calls',
    successrate: 'Reach Rate',
    totalduration: 'Total Call Duration (s)',
    average: 'Average Call Duration (s)'
  },
  taskPlan: {
    tpDone: 'Approved',
    tpWati: 'Pending ',
    tpReject: 'Rejected',
    tpBack: 'Withdrawn',
    tpCreated: 'Created',
    wait: 'The task information has been submitted. Please wait for approval.',
    planWait: 'The plan information has been submitted. Please wait for approval.',
    approveTime: 'Approval Time',
    creator: 'Created by',
    taskStatus: 'Task Status',
    planStatus: 'Plan Status',
    approve: 'Approve',
    back: 'Withdraw',
    dlList: 'Download List',
    pass: 'Approve',
    noPass: 'Reject',
    confirmBack: 'Are you sure you wish to withdraw?',
    approvalOK: 'Approved, Task Name: {name}',
    approvalNO: 'Rejected, Task Name: {name}',
    planOK: 'Approved, Plan Name: {name}',
    planNO: 'Rejected, Plan Name: {name}',
    taskBack: 'Withdraw Task: {name}',
    planBack: 'Withdraw Plan: {name}',
    planTime: 'Plan Date',
    goApprove: 'Go to Approval'
  },
  execall: {
    // executecall.vue和executecallTable和exetestForm中数据
    taskCheck: 'The execution time of the task must be longer than the redial interval * redialing times.',
    strategyCheck: 'The Strategy time must be longer than the redial interval * redialing times.',
    task: 'Task',
    DueDate: 'Due Date',
    genderselect: 'Gender',
    BorrowerName: 'Borrower Name',
    BorrowedAmount: 'Borrowed Amount',
    BorrowedDate: 'Borrowed Date',
    TotalOwingAmount: 'Total Owing Amount',
    platName: 'Platform Name',
    finished: 'Finished',
    executecall: 'Execute Call',
    taskname: 'Task Name',
    testname: 'Test Name',
    voicetemplate: 'Robot',
    calltime: 'Call Time',
    endtime: 'End Time',
    addtasks: 'Add New Task',
    addstrategy: 'Add Strategy',
    editstrategy: 'Edit Strategy',
    testcall: 'Add New Test',
    successimport: 'Imported List Number',
    updatetime: 'Update Time',
    createtime: 'Created Time',
    starttime: 'Start Time',
    callstate: 'Status',
    operation: 'Operation',
    searchinfo: 'Info',
    Filepath: 'Filepath',
    DownLoad: 'Download',
    resume: 'Resume',
    cancel: 'Cancel',
    source: 'Source',
    details: 'Details',
    pause: 'Pause',
    start: 'Start',
    progress: 'Progress',
    submit: 'Submit',
    utcselect: 'UTC selection',
    templatselect: 'Robot',
    routeselect: 'SIP',
    upload: 'Upload Data',
    expired: 'Invalid if expired',
    recall: 'Redial or not',
    timeselect: 'Time selection',
    starttimeselect: 'Start Time',
    endtimeselect: 'End Time',
    downtemplate: 'Sample',
    yes: 'Yes',
    no: 'No',
    interval: 'Re-dial Interval(minutes)',
    maxnumrecall: 'Maximum Redial Times',
    platform: 'Platform',
    reset: 'Reset',
    createdtimerange: 'Select a Creation Time',
    createdtimeto: 'Select a Creation Time',
    tianjia_task: 'Create a Task',
    addplan: 'Add a New Plan',
    planname: 'Plan Name',
    calling_strategy: 'Calling Strategy',
    sip: 'SIP',
    actions: 'Actions',
    date: 'Date',
    strategy: 'Calling Strategy',
    view: 'View',
    calleeNumber: 'Callee Number',
    calltimerange: 'Call Time Range',
    save: 'Save',
    addTask: 'Create New Task',
    importNames: 'Import Name List',
    checkNames: 'Name List Verification',
    over: 'Finish',
    input_names: 'Please upload the name list',
    download_fillin: 'Download the template and fill in information ',
    already_list: 'Upload the filled list',
    xiazai_template: 'Download the template',
    upload_names: 'Upload the name list',
    select_drug: 'Select files to upload',
    error_words: 'Confirm to ignore incorrect data, create tasks based on successfully imported name list?',
    ten_data: 'Only 10 items are displayed, more details please',
    total_error_data: 'download all failed status data',
    reject_number: 'Importing name list will exclude blacklist numbers',
    fail_list: 'Failed List',
    error_content: 'Error Content',
    renwu_list: 'Task list',
    line: 'Rows',
    all_numbers: 'Total number of name lists',
    success: 'Succeed',
    fail: 'Fail',
    add_plans: 'Add a calling plan',
    plan_name: 'Plan Name',
    check_plan: 'View Plan',
    set_plan: 'Set outbound call plan',
    round: 'Current Round',
    reupload: 'Re-Upload',
    import_result: 'Import Results',
    add_success: 'Task added successfully',
    setDialTime: 'Please wait. The call will be made at the designated time.',
    countdown: 'The page will be closed in {number} seconds',
    pre_step: 'Previous Step',
    next_step: 'Next Step',
    create_task: 'Create Task',
    project_list: 'Plan list',
    gap_times: 'Re-dialing Times',
    gap: 'Re-dial Interval',
    viewRobotIntr: 'View Robot Introduction',
    robotIntr: 'Robot Introduction',
    setOutboundCallPlan: 'Set Outbound Call Task',
    selectStartTime: 'Please select the start time first.',
    distance: 'Start in',
    halfHour: '0.5 hours',
    oneHour: '1 hour',
    oneHalfHour: '1.5 hours',
    twoHours: '2 hours',
    timeHorizon: 'Please select a time between 06:00-22:00.',
    totalCount: 'Number of Total Dialed Contacts',
    uploadCount: 'Number of Uploaded Contacts',
    distinctReachRate: 'Unique Connection Rate',
    allstrategy: 'All Strategies',
    allplan: 'All Plans',
    searchTip: 'Only call data generated after April 14, 2023 can be queried in this method.',
    day5Error: 'The start and end time cannot be later than the 5th day from the current date.',
    fileSuccess: 'File uploaded successfully'
  },
  accessControl: {
    ipBlack: 'IP Blacklist',
    ipWhite: 'IP Whitelist',
    currentIP: 'The current IP blacklist is only applicable to clients accessing via API.',
    currentIP2: 'The current IP whitelist is only applicable to clients accessing via API.',
    delIP: 'Delete IP Address',
    addIP: 'New IP Address',
    ipAdd: 'IP Address',
    addBlack: 'Add to Blacklist',
    addWhite: 'Add to Whitelist',
    editBlack: 'Edit Blacklist',
    editWhite: 'Edit Whitelist',
    ipTip: `Supports any IP address, such as 10.0.0.10 or FF05:B5; supports CIDR format addresses, such as 10.0.0.0/16 or FF05:B5/60; use line breaks to separate, and you can add up to 20 addresses at a time.`,
    required: 'Required',
    noCaseIP: 'Incorrect IP Address',
    more20: 'Enter up to 20 IP addresses',
    confirmDeleteIP: 'Are you sure you wish to delete this IP?'
  },
  webhook: {
    callback: 'Event Callback ',
    encryption: 'Encryption Policy',
    itOutbound: 'Intelligent Outbound Call',
    itInbound: 'Intelligent Inbound Call',
    addCallback: 'New Event Callback',
    editCallback: 'Edit Event Callback',
    eventType: 'Event Type',
    requestURL: 'Request URL',
    requestIP: 'Request IP',
    requestField: 'Request Parameter',
    muBack: 'Simulate Callback',
    weSupport:
      'For our traditional Webhook mode, we require you to provide a public network address for receiving event messages. When the corresponding event occurs, we will send an HTTP POST request to the public network address of your server, including the event data in the request. If you need encrypted transmission, please configure the "Encryption Policy."',
    task_detail: 'Notification of Finished Call in Task',
    task_detail_ic: 'Notification of Finished Call in Task (Info-Checker)',
    task_end: 'Notification of Task Completion',
    plan_end: 'Notification of Plan Completion',
    wf_detail: 'Notification of Finished Call in Workflow',
    wf_detail_ic: 'Notification of Finished Call in Workflow (Info-Checker)',
    wf_apinode: 'Workflow call completion and API node entry notification',
    wf_detail_end: 'Notification for Workflow List Completion',
    wf_status: 'Notification of Workflow Status Change',
    ib_transfer: 'Notification after Successful Transfer to an Agent',
    ib_detail: 'Notification after the Call Ends',
    verify: 'Verification',
    verified: 'Verified',
    verified_error: 'Verification Failed',
    stru: 'Data Structure',
    show: 'Example',
    field: 'Field',
    orMust: 'Required or Not',
    tips1: `1. API requests support the AES+SHA256 encrypted signature authentication scheme. Request parameters and response data can be encrypted using the AES algorithm during transmission to ensure that only authorized recipients can decrypt and access the data. When signing the request parameters and response data, the SHA256 algorithm is used to generate a digest. The digest is transmitted along with the request or response, and the recipient can verify the integrity of the digest to ensure the integrity of the data and prevent tampering. Currently, you can configure your encryption key (ClientEncryptionKey) for requesting us, as well as our encryption key (ServerEncryptionKey) for requesting you.`,
    tips2: '2. Some callback event data contains a signature field for verifying the integrity and security of the callback data. You can configure the CallbackSignKey for calculating the signature.',
    urlError: 'Request Address Verification Failed',
    requestEn: 'Request Key and Callback Key',
    backKey: 'Callback Signature Key',
    confirmSave: 'Confirm and Save?',
    lii: 'ClientEncryptionKey limit: 16, 24, or 32 characters',
    lii2: 'ServerEncryptionKey limit: 16, 24, or 32 characters',
    lii32: 'CallbackSignKey limit: 32 characters',
    cTooltip: 'This is the encryption key used when you request us, with a default value of "airudderredduria".',
    sTooltip: 'This is the encryption key we use when requesting you for callback events.',
    bTooltip: 'This is the parameter used to calculate the sign field in some callback events, with a default value of "airudder".',
    copySuccess: 'Copied',
    viewField: 'View Parameters',
    urlTip:
      'After clicking on "Verify," we will send an application/json;charset=utf-8 formatted POST request to the request address to verify the legitimacy of the configured address. This POST request contains simulated data for the corresponding event type. If an HTTP code of 200 is received within the retry time range, the verification is successful, otherwise, the verification fails.',
    fieldTip: 'Please note: Changing this setting will also affect the return data of the APIs including query APIs.',
    requestUrlTip: `After the request address has been verified, clicking the "Confirm" button. We will send an HTTP POST request to the server's public network address, with the request containing simulated data.`,
    noStableIP: 'No Static IP',
    plwf: 'Please configure the Call-back URL in the Workflow Template.',
    pass: 'Verified',
    noPass: 'Verification Failed'
  },
  progress: {
    // 查看进度dialog
    checkprogress: 'Check Progress',
    total: 'Total Number Uploaded',
    called: 'Total Number Called',
    unreached: 'Total Number Unreached',
    reached: 'Total Number Reached',
    ok: 'OK',
    overview: 'View',
    title: 'Uploading',
    tip: 'We are uploading the list for you. It may take a few minutes. Please be patient'
  },
  tips: {
    // 二次确认提示框
    tips: 'Note',
    start: 'Are you sure to start calling immediately?',
    cancel: 'Are you sure to cancel?',
    pause: 'Are you sure to pause?',
    resume: 'Are you sure to resume?',
    close: 'Are you sure to close?',
    close_strategy: 'Are you sure to close this page? Operations will not be saved!',
    loading: 'Loading',
    plsSelect: 'Please select',
    plsEnter: 'Please enter',
    regName: 'Please enter alphanumeric or underline',
    regPhone: 'Please enter the correct phone number',
    regUrl: 'Please enter the correct URL',
    starttip: 'Call Now',
    back: 'Back',
    confirmDel: 'Do you confirm to delete?',
    opsSuccess: 'Successful operation.',
    confirmCancel: 'Are you sure to cancel this?',
    repeat: 'This name already existed.'
  },
  testcall: {
    // testcall
    maxwarn: 'The current number of test calls has reached the limit',
    selecttimewarn: 'Please select the created time range',
    search: 'Search',
    type: 'Call Type',
    interval: 'Redial Interval (Minutes)',
    num: 'Redialing Times (Excludes the 1st time)',
    testName: 'Name of Single-Call Testing',
    test: 'Single-Call Testing',
    inputAccount: 'Please enter the account.',
    addTest: 'Adding a Call Based on Strategies',
    addTask: 'Adding a Call Based on Tasks',
    addCall: 'Add a Call',
    account: 'Account',
    taskName: 'Task Name',
    selectTask: 'Selected Task for Adding a Call',
    stime: 'Start Time (In Calling-Adding Time Zone)',
    etime: 'End Time (In Calling-Adding Time Zone)',
    sta: 'Start Time (Account Time Zone)',
    eta: 'End Time (Account Time Zone)',
    subTask: 'Subtask',
    list: 'Number of Lists',
    label: 'Intention Labels',
    robotName: 'Robot Name',
    status: 'Added Call Status',
    scs: 'Selected Call Strategies',
    callTime: 'Duration of Added Calls',
    callNum: 'Added Call Rounds',
    accountTime: 'Account Time Zone',
    addType: 'Added Call Type',
    adds: 'Added Call Strategy',
    addSet: 'Added Call Settings',
    tip: 'Note: Time is in the Account Service Time Zone.',
    sd: 'Start Date',
    ed: 'End Date',
    sat: 'Please select the Duration of Added Calls.',
    roundName: 'Round Name',
    robot: 'Robot',
    st: 'Start Time',
    et: 'End Time',
    opera: 'Operations',
    addc: 'Add a Call',
    cac: 'Cancel Adding',
    at: 'Absolute Time',
    rt: 'Relative End Time',
    atb: 'Add Tasks in Bulk',
    atbTip: 'Adding tasks in bulk is allowed. Please start a new line for a different task name.',
    adddetail: 'Details of Added Calls',
    addID: 'Added Call ID',
    cat: 'Call-Adding Task',
    pa: 'Please select an account for adding the calls.',
    aea: 'Add/Edit a Call-Adding Task',
    aib: 'Add in Bulk',
    pst: 'Please select the Start Time.',
    pet: 'Please select the End Time.',
    reset: 'Reset',
    save: 'Save',
    ln: 'Number of Lists',
    ct: 'Creation Time',
    cstatus: 'Call Status',
    remarks: 'Remarks',
    saname: 'The Task Name of the selected account.',
    rtst: 'The Call Start Time of the related task.',
    rtet: 'The Call End Time of the related task.'
  },
  taskoverview: {
    taskoverview: 'Task Overview',
    overview: 'Overview'
  },
  formrulestips: {
    // RuleForm的提示语
    taskname: 'Please enter a task name',
    strategyname: 'Please enter a strategy name',
    planname: 'Please enter a plan name',
    strategy: 'Please select a strategy',
    repeat_interval: 'Please select the redialing intervel',
    repeat_number: 'Please select the redialing times',
    intention: 'Please select intention',
    base: 'Please select base',
    voicetemplate: 'Please select robot template',
    lineselect: 'Please select a SIP line',
    starttime: 'Please enter the start time',
    date: 'Please enter the date',
    endtime: 'Please enter the end time',
    ifexpired: 'Please choose whether to invalid the one after expiration',
    ifrecall: 'Please choose whether to redial',
    recallinterval: 'Please select redial interval',
    maxnumrecall: 'Please select the maximum number of redials',
    utc: 'Please select a time zone',
    yes: 'Yes',
    no: 'No',
    uploadsuccess: 'Upload successfully',
    excelempty: 'The form is empty, upload failed',
    maxlimiation: 'The number of calls uploaded has reached the limit',
    reset: 'Reset'
  },
  form: {
    upload: 'Upload',
    uploadtip: 'Upload Contacts Info',
    submit: 'Submit!',
    error: {
      uploadsize: 'Please do not upload files larger than 1m in size.',
      uploadheader: 'There is an error in the excel header. Please fill in the data according to the template.',
      uploadnum: 'Only support uploading one file!',
      uploadformat: 'Only supports upload .xlsx, .xls, .csv suffix files',
      date: 'There is an error in the excel date，Please fill in the data according to the template.'
    },
    download: 'Download Template',
    importfail: 'Data import failed',
    allfail: 'All data import failed'
  },
  tableoperation: {
    pending: 'Pending',
    created: 'Created',
    finished: 'Finished',
    canceled: 'Canceled',
    cancel: 'Cancel',
    paused: 'Paused',
    reached: 'Reached',
    unreached: 'Unreached',
    calling: 'Calling',
    planned: 'Planned'
  },
  login: {
    login: 'Log in',
    logout: 'Logout',
    passwordLogin: 'Account & Password',
    ssoLogin: 'SSO',
    slogan: 'Increase Productivity Excellently, Driven By AI Proudly',
    footer: 'Business Cooperation: bianca.cheng@airudder.com | Copyright 2019 airudder.com',
    business_cooperation: 'Business Cooperation: sales@airudder.com',
    all_right_reserved: 'Copyright {name} airudder.com',
    input_userName: 'Please enter username',
    input_password: 'Please enter password',
    login_forget: 'Forgot Password',
    concurrency_limit: 'Your account is logged in on other devices. To ensure account security, if it was not you, please log in again and change your password immediately.',
    errorMessage: 'Your session has timed out. Please login again.',
    noRegister: 'The account is not registered. Please contact us to register and then retry.',
    noCanSSO: 'This account does not support SSO login. Please contact us for assistance.'
  },
  calldetails: {
    translationLanguage: 'Select a language',
    prevRecord: 'Last Recording',
    nextRecord: 'Next Recording',
    callId: 'Call ID',
    dialogueRounds: 'Round',
    callDetails: 'Call History',
    translation: 'Translate',
    downloadRecord: 'Download Recordings',
    calldetails: 'Call Details',
    contact: 'Name',
    callid: 'Call ID',
    callduration: 'Duration',
    intentionlabel: 'Intention',
    callresult: 'Result',
    download: 'Download Records',
    reached: 'Reached',
    unreached: 'Not reached',
    undialed: 'Not dialed',
    choosecreate: 'Select Created Time',
    choosecall: 'Select Call Time',
    callnumber: 'Phone Number',
    timefrom: 'Call Time (From)',
    timeto: 'Call Time (To)',
    calltimerange: 'Call Time Range',
    inputnumber: 'Input Number',
    ringtype: 'Ring Type',
    hangtype: 'Hang-Up Type',
    comments: 'Comments',
    questions: 'Questions',
    icresult: 'Result',
    A: 'A: success',
    B: 'B: failed',
    C: 'C: unfinished',
    D: 'D: others',
    E: 'E: no-answer',
    F: 'F: not connected',
    G: 'G: voicemail',
    Yes: 'Y: Yes,Callee confirm',
    No: 'N: No,Callee deny',
    Others: 'O: Others,No reply or meaningless reply',
    Skip: "S: Skip,Robot didn't ask",
    Non: '-: This question does not exist',
    resultTipTitle: 'The IC result category is related to robot design',
    questionsTipTitle: 'reply to each question unit',
    tableTitle: 'Detailed List',
    prompt_robot_name: 'Please select a robot',
    prompt_intention: 'Please select an intention',
    call_time: 'Start Time',
    create_time: 'Created Time',
    robot: 'Robots',
    prompt_overall_result: 'Please select a result',
    userHangup: 'Hung up by User',
    RobotHangup: 'Hung up by AI',
    agentHange: 'Hung up by Agent',
    cancelled: 'Cancelled',
    all_intention: 'All Intentions',
    all_result: 'All Results',
    lettersMeaning: 'The meaning of the Letter displayed on the right side under each question list:',
    lettersMeaningLeft: 'The meaning of the Letter displayed on the left side under each question list:',
    letterA: "A: The answer of the callee ('-' when the result is unavailable)",
    letterV: "V: The verification info you uploaded ('-' when the result is unavailable)",
    letterR: "R: The verification result of A and V ('Match' when they match; 'Not match' when they do not match; '-' when result is unavailable)",
    mainFlow: 'Main Process',
    robotPhoneLabel: 'Intention',
    isArtificial: 'Transferred to Agent or Not',
    userPhone: 'Contact Number',
    callingId: 'Call ID',
    callingTime: 'Total Call Duration',
    scenario: 'Business Scenario',
    pdfFailReason: 'Reason for Failure of Agent Transfer',
    robotCallTime: 'Robot Call Duration',
    callDuration: 'Agent Call Duration',
    dialogueRound: 'Bot Conversation Rounds',
    callTag: 'Agent Result',
    moreFilter: 'More Filters',
    visibleFields: 'The Fields to Display and Download',
    hotPhone: 'Hotline Number',
    transfer: 'Not Transferred',
    transferSuccess: 'Successfully Transferred',
    transferFail: 'Failed to Transfer',
    cantConfirm: 'Tried but unsure',
    view: 'View',
    hitMainProcess: 'Hit Main Process',
    callTaskBeginTime: 'Task Start Time',
    beginCallTime: 'Call Start Time',
    workflowName: 'Workflow Name',
    advancedSettings: 'Advanced Settings',
    canSeeFields: 'Basic Field Visibility Management ',
    nerSlots: 'NER Slots Settings',
    eventLabels: 'Event Labels Settings',
    listVariable: 'List Variable Settings',
    showTip: 'Check to control fields display, filter or download fields',
    call_task_name: 'Call Task',
    call_robot: 'Robots',
    wf_task: 'Workflow Task',
    wf_template: 'Workflow Template',
    call_plan: 'Call Plan',
    call_strategy: 'Call Strategy',
    call_id: 'Calling ID',
    phone_number: 'Phone Number',
    call_intention: 'Intention Label',
    ringing_type: 'Ring Type',
    hangup_type: 'Hangup Type',
    transfer_status: 'Transferred to Agent or Not',
    platform_name: 'Platform',
    task_call_start_time: 'Task Start Time',
    real_call_start_time: 'Call Start Time',
    ner_slots: 'NER slots',
    event_labels: 'Event labels',
    talk_duration: 'Call Duration',
    talk_round: 'Round',
    task_id: 'Task ID',
    contact_name: 'Contact Name',
    answer_time: 'Connect Time',
    real_call_end_time: 'End Call Time',
    call_times: 'Number of Calls',
    call_comments: 'Comments',
    asr_result: 'ASR Result',
    phone_call_log: 'Redial Record',
    fieldShow: 'Fields and Display Order',
    listField: 'List Fields',
    selectField: 'Enable Filter Items',
    slotsTitle: 'Slots Description and Download Header Settings',
    slotTip1: 'Note: NER slots are configured in the robot flow. All robot slots are shown here.',
    slotTip2:
      '1. Please set whether to display a slot when it is hit or not according to your need. If you check "Display", the hit slot and slot value will be displayed in the call details; if you check "NER slots" visible in the list in "Basic Field Visibility Management", the hit slot and slot value will be displayed in the call list;',
    slotTip3:
      '2. Please set the description text according to your need. If you have set the description text, the corresponding description text and slot value will be displayed when the call hits the slot; if not, the slot name and slot value will be displayed;',
    slotTip4: '3. Please set whether a certain slot can be used as a filter item according to your needs;',
    slotTip5:
      '4. Please set whether a certain slot can be used as the Excel table header of the download list after it is hit according to your needs, and other slots and slot values that are not set will be uniformly put under the NER slots table header field.',
    slotDes: 'Description ',
    canSee: 'Display or Not',
    canDl: 'Whether to Download as Table Header',
    eventTitle: 'Event Lables Download Table Header Settings',
    eventTip:
      'Description：Event labels are configured in the bot flow. Event labels of all robots are displayed here. Please configure whether to download a certain Event label as an Excel table header after it is hit according to your needs. Other Event labels will be displayed under the same header--Event labels, and please select "Event labels" in the "Basic Field Visibility Management".',
    tableDl: 'Whether to Download as Table Header',
    listSet: 'List Variables View and Download Header Settings',
    variableTip:
      'Description: Here we show all the uploaded list variables from the last 6 months to T-1 day. Please configure whether a list variable can be viewed in the call details or downloaded separately as an Excel header.',
    listTitle: 'List Variables View and Download Header Settings',
    listTip:
      'Note: All uploaded list variables from the last 6 months to T-1 day are shown here. Please set whether a list variable can be used as a filter item, displayed in the list and call details, or used as an Excel table header for the download list, as needed.',
    listVar: 'List Variables',
    callInfoTitle: 'Call Task Information',
    callInformation: 'Call Information',
    listInfo: 'List Information',
    listSource: 'List Source',
    asr_ptp: 'PTP',
    detail_status: 'List Status',
    ringing_duration: 'Ring Time',
    openFilter: 'Enable Filter',
    exception_feedback: 'Exception Feedback',
    exCategory: 'Exception Type',
    exDialogue: 'Exception Dialogue',
    submitFeedback: 'Submit Feedback',
    feedbackDetail: 'Feedback Details',
    bigLabelErr: 'Intention Error',
    asrErr: 'ASR Error',
    flowErr: 'Flow Error',
    scriptErr: 'Script Error',
    plsExType: 'Please choose the exception type.',
    plsSelectExMsg: 'Please check the dialogue with exceptions on the left.'
  },
  singeltest: {
    singeltest: 'Demo',
    template: 'Please select a robot template',
    sipselect: 'Please select a SIP',
    calling: 'Call From',
    called: 'Call To',
    tele: 'Please enter phone number',
    canused: 'Remaining Amount',
    submit: 'Submit',
    reset: 'Reset',
    numonly: 'Phone number can only be numbers',
    sip: 'SIP'
  },
  error: {
    404: 'Please check if the URL you entered is correct. Click the button below to return to the homepage.',
    back: 'Homepage',
    planadd: 'Your plan execution time has exceeded the original strategy time, please adjust the strategy and try again'
  },
  strategy: {
    newround: 'Add a New Round',
    list: 'Calling Strategy List',
    new: 'Add a New Strategy',
    published: 'Published',
    unpublished: 'Unpublished',
    view: 'View',
    edit: 'Edit',
    copy: 'Copy',
    delete: 'Delete',
    strategy: 'Strategies',
    roundname: 'Round Name',
    roundnumber: 'Number of Rounds',
    strategyname: 'Strategy Name',
    entername: 'Enter Strategy Name',
    maxrecall: 'Maximum Redialing Times',
    selecttag: 'Select a Label',
    selectrange: 'Select Range',
    tip: 'Tips: Interval between two rounds needs to be more than 15 minutes!',
    stratrgy_table: 'Strategy List',
    prompt_strategy_name: 'Please enter a strategy name',
    interval_time: 'The interval between {round} and the previous round shall be longer than 15 minutes',
    view_strategy: 'View Strategy',
    amxTag: 'A maximum of 12 labels are allowed in this round, please select again',
    no_robot: "Robot doesn't exist, please try again."
  },
  robotExplain: {
    name: 'Script Name',
    language: 'Script Language',
    voice: 'Mood',
    range: 'Applicable Range',
    paytime: 'Ask Payment Time',
    recorder_gender: 'Voice Gender',
    voice_language: 'Language',
    formal: 'Formal',
    casual: 'Casual',
    polite: 'Polite',
    natural: 'Natural',
    tough: 'Tough',
    tougher: 'Tougher',
    t4: 'T-4 or above, IVR',
    t3: 'T-3 till T0',
    t0: 'T0',
    tadd1: 'T+1 ~',
    beforedue: '~ T-1',
    today: 'Today'
  },
  excel: {
    appexist: 'Please confirm if the platform name is correct.',
    dateformat: 'The date format is invalid. Please refer to the sample template.',
    dateinterval: 'The "borrowed_date" should be earlier than "due_date"'
  },
  blacklist: {
    add: 'Add New Blacklist',
    tip1: 'Support batch uploading',
    tip2: 'Line Break is needed between phone numbers',
    invalidTip: 'Invalid phone number format',
    successTip: 'added successfully',
    deleteTip: 'Confirm to delete',
    deleteSuccess: 'deleted successfully',
    simpleTip: 'Sample',
    limit_service: 'Blacklist Limit Service',
    system_names: 'System Blacklist',
    manual_names: 'Manual Blacklist',
    bl_type: 'Blacklist Type',
    bl_list: 'Blacklist'
  },
  assistant: {
    title: 'Intelligent Blocking',
    add: 'Add an intelligent blocking strategy',
    type: 'Type',
    days: 'Screening Days',
    result: 'Calling Result',
    times: 'Total Times',
    callTimes: 'Dialing Times',
    shieldDays: 'Blocking Days',
    shieldType: 'Blocking Methods',
    lastTime: 'Last Update Time',
    tel: 'Blocked Number',
    shieldTime: 'Blocking Time',
    task: 'Task',
    shieldData: 'Check Blocking Data',
    pblj: 'Blocking Logic: When creating a task or a call, the system checks whether the calls made in the last N days meet the blocking conditions. If yes, the system will block the calls with selected methods for M days. If no, the system will not block the calls.',
    addznpbcl: 'Add an intelligent blocking strategy',
    clsm: 'Strategy descriptions',
    leftDay: 'Last N days (Screening Days)',
    rightDay: 'Next M days (Blocking Days)',
    shaft: 'Timeline',
    createCalling: 'Creating a task/ a call',
    timePoint: 'Point in time X',
    radioOne: 'Blocking according to the total times of calling results',
    radioTwo: 'Blocking according to the dialing times',
    inputOne: 'Blocking Type ',
    inputTwo: 'Screening Days ',
    inputThree: 'Blocking Conditions',
    checkboxOne: 'Block when creating a task',
    checkboxTwo: 'Block when calling',
    spanOne: 'Dialing Times',
    spanTwo: 'Calling Result',
    spanThree: 'Total Times',
    tooltip1:
      'This blocking type will block the numbers which have been labeled as selected labels xx times in last Screening Days. If there are several selected labels, then total times will be the sum of total times of all labels.',
    tooltip2: 'This blocking type will block the numbers which have been called xx times in last Screening Days.',
    tooltip3: 'Before blocking the number, Screening Days (including current day) should be selected in the strategy.',
    tooltip4:
      'It means the number (including current day) of days that targeted number will be blocked. If some number is blocked for two days from today, then it will be blocked both today and tomorrow. And blocking will end at 23:59:59 tomorrow.',
    tooltip5: 'When creating a task, the targeted number will be blocked and cannot be uploaded.',
    tooltip6: 'When calling, the targeted number will be blocked and cannot be called.',
    placeholder: 'Please enter a figure between 1~180.',
    tian: 'Day(s)',
    ci: 'Time(s)',
    shieldTimes: 'Blocking Times',
    smartNumber: 'Intelligent Blocking Times',
    rule6: 'Please enter an integer between 1~180.',
    rule7: 'Please enter an integer.',
    rule1: 'Please select a Blocking Type.',
    rule2: 'Please enter the Screening Days.',
    rule3: 'Please enter the Blocking Conditions.',
    rule4: 'Please enter the Blocking Days.',
    rule5: 'Please select a Blocking Method.',
    blockStrategy: 'Blocking Strategy',
    blockTrigger: 'Triggered Blocking Strategy',
    blockStartTime: 'Block Start Time',
    blockEndTime: 'Block End Time'
  },
  personalInfo: {
    current_password: 'Current Password ',
    input_current_password: 'Please enter current password',
    input_new_password: 'Please enter a new password',
    error_current_password: 'Password is incorrect',
    title: 'Account Information',
    group: 'Group',
    role: 'Role',
    account: 'Account Name',
    icon: 'Photo Icon',
    resetIcon: 'Modify Photo Icon',
    accountInfo: 'Account Details',
    basicInfo: 'Basic Information',
    new_password: 'New Password',
    error_confirm_password: 'The passwords do not match'
  },
  message: {
    lessCurrentTime: 'The start time cannot be earlier than the current time.',
    lessFiveMin: 'The interval between end time and start time cannot be less than 5 minutes',
    errorStrategyTime: 'Strategy Start Time is earlier than now, plan create failed',
    fail: 'All imported name list failed',
    upload: 'Please upload the name list'
  },
  robot: {
    detail: 'View Details',
    valid: 'Valid',
    invalid: 'Invalid',
    state: 'Status',
    action: 'Operate',
    robot_name: 'Robot Name',
    create_time: 'Created Time',
    update_time: 'Update Time',
    audition: 'Audition',
    now_words: 'Current Script',
    words_list: 'Script List',
    history: 'Operating History',
    create_words: 'Create a new Script',
    update_words: 'Edit Script',
    words_update: 'Edit Script',
    words_preview: 'Preview Script',
    words: 'Script',
    apply: 'Apply',
    update: 'Edit',
    delete: 'Delete',
    fill_words: 'Fill in Audition Variables',
    start_audition: 'Start playing',
    confirm_delete: 'Are you sure to delete the Script',
    confirm_apply: 'Are you sure to applicate the Script',
    sensitive_word: 'is a sensitive word. Please replace it and try again. ',
    suggest_cut: 'More than 90s, please shorten the script.',
    add_words: 'Add new Script',
    apply_words: 'Applicate Scripts',
    delete_words: 'Delete Scripts',
    explain: 'Note: Please copy the parameters you want to text box for script editing',
    all_params: 'All the Parameters',
    params_explain: 'Parameter Description',
    submit: 'Submit',
    serial_number: 'Sequence Number',
    operation_type: 'Operation Type',
    operation_time: 'Operation Time',
    operator: 'Operator',
    can_not_empty: "Scripts can't be empty",
    integrity: 'Please complete the variables for audition',
    greetings: 'Greeting, generated automatically based on the call time',
    borrower_name: 'User name, In tele-marketing services, this parameter corresponds to customer_name in the template ',
    gender: "User's gender",
    borrow_money: 'Borrowed amount, corresponds to the borrowed_amount in the template',
    borrow_total_money: 'Total amount borrowed, corresponds to the total_owing_amount in the template',
    borrow_date: 'Borrowed date, corresponds to the borrowed_date in the template',
    due_date: 'Loan Due Date',
    due_days: `Overdue days: automatically converted according to due_date and needn't upload`,
    due_month: `Overdue Month: automatically converted according to due_date and needn't upload`,
    platform: 'Platform name, corresponds to platform_name in the template',
    borrow_month: `Loan month: automatically converted according to borrow_date and needn't upload`,
    extra_a: 'Expanded Parameter',
    extra_b: 'Expanded Parameter',
    extra_c: 'Expanded Parameter',
    extra_d: 'Expanded Parameter',
    enter: 'Please enter',
    active: 'Valid',
    ineffective: 'Invalid',
    edit_remark: 'Edit Remarks',
    remark: 'Remarks',
    remark_max_length: 'Maximum length of Remarks is 40 characters',
    robotId: 'Robot ID',
    idDesc: 'This ID is mainly used to select the corresponding robot during API connection.',
    tone: 'Tone',
    robotGender: 'Gender',
    auditionRecord: 'Play Audio Demo',
    politeness: 'Polite',
    nature: 'Natural',
    tough: 'Harsh',
    pressure: 'Pressing',
    cruel: 'Fierce',
    detailTab1: 'Label Description',
    detailTab2: 'Robot Variables',
    detailTable1: 'Label',
    detailTable2: 'Description',
    detailTable3: 'Variables',
    detailTable4: 'Rules',
    detailTable5: 'Examples',
    labelGroup: 'Categorize Event Labels',
    groupTip: 'Note: The event labels under the same robot can be set in groups. After settings, the group name will be displayed; without grouping, only the original event labels will be displayed.',
    groupbtn1: 'Group',
    groupbtn2: 'Remove Grouping',
    groupbtn3: 'Group name',
    errTip: 'Please select multi_intention',
    groupTableTitle: 'Event Label Group',
    dashboardTip1: 'The Label Priority is set as {name}. Distinction will be based on this priority.',
    dashboardTip2:
      'All the numbers refers to all the numbers in the lists, the Label Priority is {name}. If there are several different labels for the same phone number in the previous rounds, the system will select the lists according to the Label Priority.',
    dashboardTip3: 'Here presents the web variables and their examples; for API variables, please refer to the API docs.'
  },
  safetyLogin: {
    change_email: 'Change Email Address',
    desc_new_email: 'Please enter a new email address for verification',
    binding_email: 'Bind Email address',
    desc_email: 'Please enter email address for verification',
    to_bind: 'Bind your email',
    prompt_email: 'Please enter email address',
    invalid_email: 'Invalid email address',
    enter_code: 'Please enter verification code',
    fetch_code: 'Get Verification Code',
    area_code: 'Phone Number Area Code',
    prompt_mobile: 'Please enter phone number',
    bind_mobile: 'Bind phone number',
    invalid_mobile: 'Invalid phone number',
    error_code: 'Incorrect verification code, please try again',
    prompt_area_code: 'Please select an international telephone area code',
    again: 'Re-send after {number}s',
    safety_verification: 'Safety Verification',
    verify_desc: 'To ensure that this is your account, please verify via email.'
  },
  crossLogin: {
    name: 'Impersonate',
    list: 'Account List',
    companyName: 'Company Name',
    placeholder: 'Please enter login account or company name',
    tip: 'This is User Impersonation. The current operation is not supported.',
    checkout: 'Log-out'
  },
  LoginInfo: {
    login_set: 'Login Settings',
    enabled: 'Enabled',
    not_enabled: 'Not Enabled',
    declare: 'Note: For account security, recommended to turn on 2FA; after turning it on, bind your email to receive a verification code during security verification',
    login_log: 'Login Records',
    desc: 'The following is your login record in the last month. If there is any abnormal login record, please change your password as soon as possible',
    open_FA: 'Enable 2FA',
    serial: 'Serial Number',
    equipment: 'Equipment System',
    browser: 'Browser',
    area: 'Area',
    login_time: 'Login Time'
  },
  template: {
    callTime: 'Call Time',
    experience_robot: 'Experience the Robot',
    select_industry: 'Choose an industry',
    desc_first: 'Please choose a suitable robot for calling experience according to your needs',
    desc_second: 'The content you filled will be automatically sync into the robot scripts',
    ps_industry_scenario: 'Please select an industry-scenario',
    ps_kansalliskieli: 'Please select a country-language',
    industry: 'Industry',
    ps_industry: 'Please select an industry',
    scenario: 'Scenario',
    ps_scenario: 'Please select a scenario',
    dial_country: 'Dialing Country',
    ps_dial_country: 'Please select a dialing country',
    robot_language: 'Robot Language',
    ps_robot_language: 'Please select a robot language',
    time_zone: 'Time Zone',
    select_time: 'Please select a time zone',
    dial: 'Dialing Number',
    pe_dial: 'Please select a dialing number',
    country_code: 'Country Code',
    pe_borrower_name: `Please enter the borrower's name`,
    pe_borrowing_balance: 'Please enter the amount of money borrowed',
    total_amount_borrowed: 'Total Amount Borrowed',
    pe_total_amount_borrowed: 'Please enter the total amount borrowed',
    ps_Later_current_time: 'Please enter a time later than current time',
    length_limit: 'Length should be between 8-20 characters',
    ps_start_time: 'Please enter a start time',
    ps_borrowing_date: 'Please enter the borrowed date',
    ps_due_date: 'Please enter the due date',
    country: 'Country',
    language: 'Language',
    recording_audition: 'Audio Demo',
    experience_immediately: 'Experience Now',
    selectIndustry: 'Select the industry and scenario',
    industryList: 'Industry Menu',
    robot: 'Robot',
    timbre: 'Gender of the Voice',
    tone: 'Tone',
    rangeApplication: 'Scope of application',
    allIndustry: 'All industries'
  },
  tools: {
    manual: 'Operating Manual',
    document: 'API Documents',
    product: 'Business',
    tip1: 'Please select a business',
    tip2: 'Please select a language',
    download_doc: 'Download the Documents',
    all: 'Mark All as Read',
    infoList: 'Message List',
    more: 'View More',
    viewNow: 'View Now',
    newVersion: 'Latest Version',
    hisVersion: 'Previous Versions'
  },
  action: {
    listTime: 'Operation Time',
    list: 'Operation List',
    listAccount: 'Operation Account',
    listModule: 'Operation Module',
    listContent: 'Operations',
    taskAdd: 'Create a task {name}',
    taskOpen: 'Start a task {name}',
    taskCancel: 'Cancel a task {name}',
    taskStop: 'Pause a task {name}',
    taskRecover: 'Resume a task {name}',
    taskDownloadList: 'Download Task Lists',
    taskDownloadName: 'Download Task Name Lists {name}',
    taskDownloadDetail: 'Download Task Details {name}',
    planAdd: 'Add a plan {name}',
    planCancel: 'Cancel a plan {name}',
    planDownloadList: 'Download Plan Lists',
    planDownloadName: 'Download Plan Name Lists {name}',
    strategyAdd: 'Add a strategy {name}',
    strategyEdit: 'Edit a strategy {name}',
    strategyDelete: 'Delete a strategy {name}',
    callDetail: 'Download Call Details',
    blackListAdd: 'Add a blacklist',
    blackListDelete: 'Delete a blacklist',
    blackListDownload: 'Download a blacklist',
    shieldAdd: 'Add an intelligent blocking strategy {name}',
    shieldEdit: 'Edit an intelligent blocking strategy {name}',
    shieldDelete: 'Delete an intelligent blocking strategy {name}',
    shieldStop: 'Disable an intelligent blocking strategy {name}',
    shieldOpen: 'Enable an intelligent blocking strategy {name}',
    robotDownload: 'Download a robot',
    robotEdit: 'Edit the remark of {name}',
    robotAdd: 'Add a new script to {name}',
    robotEditWord: 'Edit the script of {name}',
    robotApply: 'Apply the script of {name}',
    robotDelete: 'Delete the script of {name}',
    createTask: 'Create a task {name}',
    createPlan: 'Create a plan {name}',
    callDelete: 'Cancel the calling of {name}',
    crossLogin: 'Impersonate {name}',
    tip: 'The followings are the records of all the operations of all the accounts bound to your company. The records of last six months are available.',
    templateSave: 'Save',
    templateDel: 'Delete',
    workflowAdd: 'Add',
    workflowAddList: 'Add a List',
    workflowCancel: 'Cancel',
    versionSave: 'Save',
    versionPublish: 'Release',
    versionActive: 'Activate',
    versionArchive: 'Archive',
    versionSaveDes: 'Save the Description'
  },
  downloadCenter: {
    downloadCenter: 'Download Center',
    progress: 'Preparing data',
    create: 'Pending, expected to start processing within 5 minutes.',
    rehandling: 'Click to reprocess',
    status5: 'Writing data'
  },
  workFlow: {
    list: 'Workflow List',
    add: 'New Workflow Template',
    workflowName: 'Workflow Template Name',
    placeholder: 'Please enter the Workflow Name',
    name: 'Template Name',
    dec: 'Description',
    modifyUser: 'Operator',
    listNum: 'Number of Lists',
    checkTask: 'View Subtasks',
    addList: 'Add list',
    setTask: 'Set up Workflow Tasks',
    inputName: 'Please enter the name',
    inputDes: 'Please enter the description',
    timeType: 'Trigger Methods',
    timeType1: 'Trigger at a specified time',
    timeType2: 'Trigger after a certain time',
    timeTip1: 'Specify the trigger time and date',
    timeTip2: 'Specify the certain time period after the associated Action is completed',
    timeTitle: 'Trigger Time',
    timeTip3: 'Please select a date',
    timeTip4: 'Please select a time',

    // TimeV2 Drawer
    timeV2Type: 'Release Method',
    timeV2Type1: 'Release at the Specified Time',
    timeV2Type2: 'Release after Certain Time',
    timeV2Tip1: 'The list will stay on the current node until reaching the set time, then it will be released to the subsequent node.',
    timeV2Tip2: 'The list will stay on the current node for set time, then it will be released to the subsequent node.',
    timeV2AbsoluteDateTitle: 'Date',
    timeV2AbsoluteDateType1: 'When the list enters the current node',
    timeV2AbsoluteDateType2: 'When uploading the list to Workflow',
    timeV2AbsoluteTimeTitle: 'Time',
    timeV2AbsoluteTimeCurrent: 'Current Time',
    timeV2RelativeTimeTitle: 'Certain Time',
    timeV2RelativeTimeHour: 'h',
    timeV2RelativeTimeMinute: 'min',
    dateTime: 'Custom Time',

    manualTitle1: 'Settings of Web Reminder',
    manualTitle2: 'Message Sending Time',
    manualTip: 'Specify the certain time period after the latest Action is completed to remind you in the Calling Message Center',
    uslTitle1: 'Condition',
    uslTitle2: 'Label Type ',
    uslTitle3: 'Robot',
    uslTitle4: 'Intention Labels',
    uslTitle5: 'Event Labels',
    uslTitle6: 'Add an "Or" condition',
    uslTitle7: 'Add an Event Label',
    splitterTitle1: 'Group',
    splitterTitle2: 'Add a group',
    splitterTitle3: 'Total percentage of data of the experimental groups must add up to 100%',
    caTitle1: 'Subcondition',
    caTitle2: 'Attribute Name',
    caTitle3: '  Data Type',
    caTitle4: 'Relation',
    caTitle5: 'Add an "And" subcondition',
    caTitle6: 'Number',
    caTitle7: ' Character',
    caTitle8: 'Date',
    caTitle9: 'Time',
    apiTip1: 'API Action will return the execution results of other Actions. Please refer to the AI Rudder API documents for details.',

    // OBCall Drawer
    ocTitle1: 'Redial Interval',
    ocTitle2: 'Redialing Times',
    ocTitle3: 'List Management Strategy',
    ocTitle4: 'Maximum Number of Lists Per Batch',
    ocTitle5: 'Wait Time Per Batch',
    ocTip1: 'Manage and release Outbound Calls by Batch.',
    ocTip2: 'If the number of lists exceeds the set threshold, a batch will be created to call out right away.',
    ocTip3: 'If the time exceeds the set threshold,  a batch will be created to call out right away.',
    ocTitle6: 'Automatic Calculation of Task Duration',
    ocTitle7: 'Outbound Task Duration',
    ocTip4: 'Calculation Formula:',
    ocTip5: 'Task Duration (min)=redialing interval*redialing times+30min',
    ocTip6: 'Task Duration (min)=number of contacts*(redialing times+1)/available concurrency+redialing interval*redialing times+5min',
    ocEditBtn: 'Edit',
    ocLimit: 'Silakan masukkan 10～1440.',

    smsTitle1: 'Content',
    smsTitle2: 'Channels',
    smsTitle3: 'SMS Characters',
    smsTitle4: 'Change Template',
    smsTitle5: 'Choose SMS Template',
    smsTitle6: 'SMS Template List',
    smsTitle7: 'Select WhatsApp Template',
    smsTitle8: 'WhatsApp Template List',
    smsTitle9: 'Confirm',
    smsTable1: 'Template Name',
    smsTable2: 'Content',
    smsTable3: 'SMS Channels',
    smsTable4: 'Number of Characters',
    pending: 'In progress',
    taskType: 'Task Type',
    checkLabel: 'Please select an Intention Label or Event Label',
    include: 'Contains',
    exclude: 'Excludes',
    startswith: 'Start with',
    endwith: 'Ends with',
    cancelTip: 'The task cannot be resumed after cancellation. Are you sure you want to proceed?',
    uliTip: 'Fill in at least one Intention Label or one Event Label',
    childPending: 'Pending',
    searchTip: 'All Workflows',
    childName: 'Subtask Name',
    callName: 'Task Name',
    clickRateTip2: 'The denominator used for calculating the click-through rate is the total number of messages sent, not the number of messages successfully delivered. It is for reference only.',

    // PDS Drawer
    pdsTitle1: 'Agent Group',
    pdsTitle2: 'Agent Calls Interval',
    pdsTitle3: 'Type of Slot Fill Factor',
    pdsTitle4: 'Automatic',
    pdsTitle5: 'Manual',
    pdsTitle6: 'Maximum Ring Time',
    pdsTitle7: 'Minimum Number of Entries in List',
    pdsTitle8: 'Task Wait Time',
    pdsTitle9: 'Voicemail Detection',
    pdsTitle10: 'Detection Time of Voicemails',
    pdsTip1: 'If the time exceeds Maximum Ring Time before it is answered, then the system will end the call. (The maximum time is 180 seconds.)',
    pdsTip2: 'When the number of lists flowed into the node is larger than the set Minimum Number of Lists, then the PDS task will be triggered immediately.',
    pdsTip3: 'When the time between the first and the last lists flowed into the node exceeds the set time, then the PDS task will be triggered immediately.',
    pdsTip4: 'After the task is completed, QA will be executed automatically.',
    pdsTip5: 'Voicemail will be detected, and only non-voicemail calls will be assigned to an agent.',
    pdsTip6: 'The maximum length of a voicemail detection, and after the set time calls will be deemed as non-voicemail calls.',
    pdsTip7: 'Redial Interval for Unconnected Calls',
    pdsTip8: 'Maximum Redialing Times for Unconnected Calls',

    urlClickTitle: 'Short Link Expiration Time',
    apiTip: 'The API Action will return the execution results of other Actions, the request method is POST, please refer to the API documentation provided by AIRudder for details.',
    humanAgentTitle: 'Dialogue Results',
    overview: 'Data Overview',
    dataTip1: 'Number of Lists Awaiting Processing',
    dataTip2: 'In Progress',
    dataTip3: 'Completed',
    dataTip4: 'Reached Calls',
    dataTip5: 'Connection Rate',
    dataTip6: 'Sent',
    dataTip7: 'Clicks (Within 7 days)',
    dataTip8: 'Clickthrough Rate (Within 7 days)',
    blocked: 'Blocked',
    labelTitle: 'Intention Distribution',
    immediately: 'Trigger Immediately',
    obcallTitle: 'Upstream OB Call Node',
    allDataView: 'Data Overview',
    coTitle1: 'Select Nodes',
    coTitle2: 'Node',
    coTitle3: 'Set up the Priority of Intention Labels',
    coTitle4: 'Set up Splitting Conditions',
    coTitle5: 'Splitting Conditions',
    coTitle6: 'Add a New Splitting Condition',
    coTitle7: 'Add a New Node',
    coTip1: 'Please select the nodes that need to fix the Intention Labels according to the priority. ',
    coTip2: 'Please modify the priority in the format of " Labels" with ">", e.g. "C>A>B>D>H>E>G>F".',
    coTip3: 'Flow splitting conditions will be displayed when matching nodes, and they should not be the same.',
    chartTitle1: 'Final Label Distribution',
    chartTitle2: 'Number of Actions during List Circulation',
    chartTitle3: 'Status of List Circulation',
    chartSelect2: 'All Channels',
    chartSelect3: 'All Final Labels',
    checkTitle1: 'It has been working',
    checkTitle2: 'Days',
    checkTitle3: 'Hours',
    checkTitle4: 'Minutes',
    checkTitle5: 'List Upload Time Frame',
    actionViewTitle: 'Config Information',
    dataTip9: 'Number of Lists Handled',
    isClick: 'Clicked or Not within 7 Days',
    clickTime: 'Click Time',
    existName: 'The node name already exists, please modify it and try again.',
    viewTip1: 'Total Number of Lists uploaded to workflow task within screening period of time.',
    viewTip2: 'Average Number of Outbound Dialing Times during circulation within screening period of time.',
    viewTip3: 'Average Number of Actions during circulation within screening period of time. (Excludes API actions.)',
    viewTip4: 'Total Number of Outbound Diaing Times within screening period of time. (Excludes redialing times in the action.)',
    viewTip5: 'Total Number of Connected Calls within screening period of time.',
    viewTip6: 'Total Outbound Call Connection Rate within screening period of time.',
    viewTip7: 'Total Number of SMS sent within screening period of time.',
    viewTip8: 'Number of SMS Short Link Clicks within 7 days since sent under screening period of time. (Only first-time click will be counted.)',
    viewTip9: 'Clickthrough Rate of SMS Short Link within 7 days since sent under screening period of time.',
    viewTip10: 'Total Number of WhatsApp Sent within screening period of time.',
    viewTip11: 'Number of WhatsApp Short Link Clicks within 7 days since sent under screening period of time. (Only first-time click will be counted.)',
    viewTip12: 'Clickthrough Rate of Short Link within 7 days since sent under screening period of time.',
    viewTip13: 'Total Dialing Times of PDS within screening period of time.',
    viewTip14: 'Total Number of PDS Reached Calls within screening period of time.',
    viewTip15: 'Total Connection Rate of PDS within screening period of time.',
    viewTitle1: 'Distribution of Final Labels within screening period of time.',
    viewTitle2: 'Number of actions taken before the output of final labels within screening period of time. (Excludes API actions.)',
    viewTitle3: 'The split of lists between actions within screening period of time.',
    urlClickTitle1: 'Node SMS/WA',
    caTitle10: 'Sub-conditions ',
    slotTip: 'The Trigger Time is determined by the slot selected, at which point the list will be moved to the subsequent process.',
    slotTitle1: 'OB Call Node',
    slotTitle2: 'Slots',
    slotTitle3: 'Trigger Method',
    slotSelect1: 'On-time trigger',
    slotSelect2: 'Trigger at an eariler time',
    slotSelect3: 'Trigger at a later time',
    nowDay: 'The Day',
    howDay: 'Day{name}',
    delTip:
      'Deleting this node will affect the data of {name} and other nodes that have referenced this node, causing exceptions to workflow. Please modify the data of affected nodes immediately after deleting this node.',
    saveTip: '{name} message has not been saved, please save and try again.',
    everyDay: 'Every Day',
    ocsTitle1: 'Round Name',
    ocsTitle2: 'Follow-up Round and Labels',
    ocsTitle3: 'Intention/ Event Labels',
    ocsTitle4: 'Round',
    ocsTitle5: 'Add a new Round',
    ocsSort: 'Reorder Rounds on time ',
    ocsError1: 'The earliest follow-up round must be selected as "Initial".',
    ocsError2: 'The Dialing Time Period of {name} should be bigger than Redial Interval*Redial Times.',
    ocsError3: 'The Start Time of {name} should be later than the End Time of {target}.',
    ocsError4: 'The round and labels of {name} and {target} have duplicate',
    ocsError5: 'The Round Name have duplicate.',
    ocsError6: 'Only one follow-up round can be selected as "Initial".',
    ocsError7: 'Only one All rounds can be selected as followup round.',
    obcallTitle2: 'Previous PDS Node',
    close: 'Close',
    errorTip1: 'There is no other Nodes pointing to the current Node.',
    errorTip2: 'The set Trigger Time is too early or too late.',
    errorTip3: 'The set Trigger Date is too late.',
    errorTip4: 'There is no set exit where the splitting condition equals others.',
    btn1: 'Self-inspection',
    btn2: 'Release',
    btn3: 'Settings',
    autoSave: 'Being saved automatically.',
    autoSave1: 'Auto-save',
    autoSave2: 'Auto-save Interval',
    min: 'min(s)',
    on: 'Enabled',
    off: 'Disabled',
    commonSetting: 'General Settings',
    nodeSetting: 'Batch Node Settings',
    errTipTitle: '{name} mistakes have been found.',
    errTipTip: 'Tips: Click the Node Name to auto-locate the problematic Node.',
    againCheck: 'Re-inspection',
    saveSuccess: 'Saved as drafts.',
    checkSuccess: 'Self-inspection passed. ',
    apiTitle2: 'Previous Node',
    apiTitle3: 'Custom Data',
    apiTitle4: 'Field Name',
    apiTitle5: 'Value',
    apiTitle6: 'New Field',
    apiTip3: 'API Action returns the execution result of other actions. Please refer to',
    apiTip4: 'The API docs provided by AIRudder for more details.',
    apiTip5: 'Field Name already exists.',
    apiVerify: 'Verification',
    apiVerifySuccess: 'Verified',
    apiVerifyFail: 'Verification Failed',
    apiVerifyWarn: 'Please verify first.',
    endtimeTip: 'The workflow task will only end at the specified time, even if all the current contact have been executed.',
    autoFinishTip: 'The workflow task will end automatically when all the contacts are executed for the last node.',
    pdsReason: 'Reason for Transfer',
    pdsReasonTip: 'Reason for transfer is displayed on the Incoming Call page for agents to view.',
    batchModify: 'Batch Edit',
    components: 'Component',
    addComponents: 'New Component',
    editComponents: 'Edit Component',
    saveNew: 'Save as New Component',
    associationTemplate: 'Same as Template Configuration',
    processConfig: 'View Component',
    inputVersionDes: 'Please enter the version description.',
    tempDesc: 'Template Description',
    viewComponentExecutionDetails: 'View Component Details',
    delComponent: 'Delete Component',
    delComponentTip: 'Are you sure to delete the component?',
    nohaveinputoroutput: 'The Input or Output node is missing.',
    noComponent: 'No available component, please create a new one first.',
    autoFinish: 'Auto End',
    delTips: 'Are you sure to delete [{name}]?',
    tips: 'Tips',
    pdsTitle11: 'Contact Number Interval',
    pdsTip9: 'The call interval between different contact numbers of one contact.',
    dnc: 'DNC Strategy',
    year: 'Year',
    holidayType1: 'Release when the date falls into one of the following categories.',
    holidayType2: 'Release when the date does not fall into any following categories.',
    holidayTask1: 'Suspended on Holidays',
    holidayTask2: 'Suspended on',
    holidayTip: `"Suspended on Holidays" refers to the logic where a workflow task, upon starting its execution, or at 05:00 hours daily based on the account's time zone, checks if the current day falls under the designated holiday category for pausing. If it does, the workflow task automatically pauses for one day and remains paused until it is re-evaluated at 05:00 hours the following day.`,
    mail1: 'Recipients',
    mail2: 'Sender',
    mail3: 'Email Template List',
    mail4: 'Select Email Template List',

    // timev2
    noVariable: 'Fixed Date and Time',
    allVariable: 'Variable Date and Time',
    fixVariable: 'Fixed Date with Variable Time',
    fixVariable2: 'Variable Date with Fixed Time',

    // waba template
    wabaAccount: 'WABA Account',
    templateName: 'Template Name',
    templateContent: 'Template Content',
    contentView: 'Preview',
    selectWABATemplate: 'Select WABA template',
    wabaAccountAnd: 'WABA account and template list',
    preview: 'Preview',
    relateChatbot: 'Associate with Chatbot',
    selectChatbot: 'Select Chatbot',
    robotVersion: 'Bot Version',
    noRelateCb: 'No Chatbot Associated',
    preOnline: 'To be Launched',
    online: 'Online',
    noRelate: 'Not associated',
    selectRobot: 'There is no to be launched or online version of the selected bot.',
    selectVersion: 'Version status is not to be launched or online.',

    // data overview
    wfTemplate: 'Workflow Templates and Versions',
    callListTrend: 'Trends of number of Contacts Dialed',
    allLabel: 'All Intentions',
    labelDistriTrend: 'Trend of Intention Distribution',
    callDurationDistri: 'Call Duration Distribution',
    callDurationTrend: 'Trend of Call Duration Distribution',
    ringDistribution: 'Ring Type',
    uploadListTrend: 'Trend of Contacts Uploaded',
    hangUpDistribution: 'Hangup Type',
    transferTrend: 'Transfer Rate Trend',
    successNum: 'Number of Successful Transfers',
    dupListNum: 'Unique Contacts',
    cancelListNum: 'Cancelled Contacts',
    updateListNum: 'Updated Contacts',
    createWFTaskNum: 'Workflow Tasks Created',
    runningWFTaskNum: 'Ongoing Workflow Tasks ',
    theSameNum: ', after de-duplicating different intentions of the same phone number, the result with the highest priority will be taken',
    redialListNumber: 'Unique Contacts Dialed',
    deconnecting: 'Number of Unique Contacts Reached',
    disconnection: 'Unique Connection Rate',
    callNumbers: 'Dialed Calls',
    rounds: 'Connected Calls',
    connectionRate: 'Total Connection Rate',
    connectedCalls: 'Average Dials',
    averageNumber: 'Average Call Attempts',
    numberConnectedCalls: 'Average Attempts Per Connected Call',
    averageCallDuration: 'Average Call Duration (s)',
    interactive: 'Average Number of Interaction Rounds',
    ringingDuration: 'Average Ringing Duration (s)',
    turnLaborNumber: 'Attempts to transfer to agents',
    transferLaborRate: 'Attempted Transfer Rate',
    successfulTransfers: 'Number of Successful Transfers',
    successRate: 'Transfer Successful Rate',
    shortMessage: 'Contacts Sent',
    singularName: 'Unique Contacts Sent',
    waShortMessage: 'Total WhatsApp Sent Contacts',
    waSingularName: 'WhatsApp Sent Unique Contacts',
    day7Hits: 'Clicked in 7 days after deduplication',
    clickThroughRate: 'Unique Click-through Rate',
    transmissions: 'Total Sent',
    day7HitsTotal: 'Total 7-day Clicked',
    clickRate: 'Click-through Rate',
    averageTransmissions: 'Average Number of Sends',
    messageSendingLists: 'Trend of Contacts Sent',
    clickRateTrend: 'Click-through Rate Trend',
    sendNum: 'Messages Sent',
    click7: 'Clicked in 7 days',
    pdsListNum: 'PDS Contacts',
    pdsDepListNum: 'Number of PDS Unique Contacts',
    pdsTitle: 'PDS Contacts Trend',
    waSend: 'Total number of Contacts sent WA Template',
    waDupSend: 'Unique Contacts sent WA Template',
    allSend: 'Total Sent',
    averageSend: 'Average Number of Sends',
    waSend2: 'Trends in the number of WA Template sent Contacts',
    waSendNumTrend: 'Trend in Number of Sends',
    includeUpload: 'Include all uploaded and added contacts',
    defaultCallNum: 'By default, the contacts are de-duplicated according to the phone number, if there are duplicate phone numbers in different workflows, they will also be de-duplicated',
    defaultCallNum2: 'By default, data will be deduplicated by selected unique dimension. Duplicates in different workflows are uniformly de-duplicated.',
    cancelSuccess: 'Contacts Cancelled Successfully',
    updateMessage: 'Contacts Updated Successfully',
    createSuccess: 'Workflow Tasks Created Successfully',
    producingTasks: 'Ongoing Workflow Tasks ',
    everyDay1: 'Daily changes of all uploaded and added Contacts, de-duplicated by phone number by default.',
    everyDay2: 'Daily changes to all lists that have been uploaded and added. The unique rule is to deduplicate according to the selected dimension.',
    onlyT1: 'Only supports downloading T-1 offline data',
    allList: 'Total number of lists in the workflow uploaded that have been dialed at least once.',
    atCallNum: 'Total number of dialed lists after de-duplication by phone number.',
    atCallNum2: 'Total number of dialed lists after de-duplication by the selected de-duplication dimension.',
    receivedAtLeast: 'Total number of connected lists in the workflow uploaded after de-duplication by phone number.',
    receivedAtLeast2: 'Total number of connected lists in the workflow uploaded after de-duplication by the selected de-duplication dimension.',
    dereferenceRate: 'Ratio of de-duped connected list numbers to de-duped dialed list numbers.',
    missedRedials: 'Total number of times all lists have been dialed, excluding redial attempts within the same round.',
    numberRounds: 'Total number of successful call connections.',
    numberCalls: 'Ratio of total successful connections to total dials.',
    averageRounds: 'Average number of times connected calls have been dialed, excluding redial attempts within the same round (this field is not affected by robot and platform filter selections).',
    averageCallNum: 'Average number of times each phone has been dialed, including attempts within the same round (this field is not affected by robot and platform filter selections).',
    connectedNum: 'Average number of times connected calls have been dialed, including attempts within the same round (this field is not affected by robot and platform filter selections).',
    averageDuration: 'Average Call Duration for Reached Calls',
    averageActive: 'Average number of active interaction rounds for reached calls',
    averageRing: 'Average ring time of dialed calls, excluding redial attempts within the same round.',
    numberAttempts: 'Number of attempts to transfer dialed calls to an agent, excluding redial attempts within the same round.',
    attemptedTransfer: 'Ratio of attempts to transfer to human to total successful connections.',
    successfulCallsTransferred: 'Number of successful transfers of dialed calls to an agent, excluding redial attempts within the same round.',
    proportionCalls: 'Ratio of successful transfers to human to attempts to transfer.',
    dialedListChanges: 'Daily distribution of the total dialed list numbers and de-duped dialed list numbers.',
    theDeduplicationRule: 'Distribution of all call intentions and de-duped intentions, de-duped by phone number and intention priority.',
    theDeduplicationRule2: 'Distribution of all call intentions and de-duped intentions, de-duped by the selected de-duplication dimension and intention priority.',
    dailyCall: 'Daily distribution of all call intentions and de-duped intentions, de-duped by phone number and intention priority.',
    dailyCall2: 'Daily distribution of all call intentions and de-duped intentions, de-duped by the selected de-duplication dimension and intention priority.',
    basedPhone: 'Daily distribution of de-emphasized and non-de-emphasized data for total number of calls made, number of connections, and connection rate.',
    allConnectedCalls: 'Distribution of call duration of all reached calls',
    durationDistribution: 'Daily distribution of the call duration of connected calls.',
    ringTypes: 'Distribution of Ring Types in All Dialed Calls',
    hangUpTypes: 'Distribution of hangup types among all dialed calls',
    transferTate: 'Daily distribution of the number of transfers, attempted transfers, and transfer rates for connected calls.',
    sentMessages: 'Total SMS Sent Contacts',
    messagesSent: 'Total Sent Contacts unique by phone number',
    messagesSent2: 'Total number of sent message lists after deduplicated by the selected dimension',
    afterSending: 'The number of clicks unique by the phone number, only counting the short link was clicked within 7 days after sending',
    afterSending2: 'The number of clicks unique by the selected dimension, only counting the short link was clicked within 7 days after sending',
    rateSfter: 'Click-through Rate after De-duplication by Number',
    shortChain: 'Only count whether the short link is clicked within 7 days after sending, and only count the earliest one if it is clicked many times',
    averageNumberMessage: 'Average Number of Sends',
    listSentmessages: 'Changes in the list of sent messages on a daily basis, unique by the phone number',
    listSentmessages2: 'Changes in the list of sent messages on a daily basis, unique by the selected deduplication dimension',
    clickRateSent: 'Daily click-through rate changes of sent messages, data updated on T+1 day, unique by the phone number',
    clickRateSent2: 'Changes in click-through rate of sent messages per day, data updated on T+1 day, unique by the selected deduplication dimension',
    nodesToEnter: 'Number of Contacts entering PDS nodes (more data available on AICC platform)',
    deduplicationLists: 'Number of de-duplicated Contacts entering the PDS node, de-duplicated by phone number',
    deduplicationLists2: 'Unique Number of lists entered into the PDS node, unique by the selected deduplication dimension',
    listOfPDS: 'Changes in the list of daily entries to the PDS node, unique by the phone number',
    listOfPDS2: 'Changes in the list of daily entries into the PDS node, unique by the selected deduplication dimension',
    WATemplateMessages: 'Changes in the list who have been sent WA Template messages on a daily basis, unique by the phone number',
    WATemplateMessages2: 'Changes in the list who have been sent WA Template messages on a daily basis, unique by the selected deduplication dimension',
    timesThatWA: 'Trend in the number of WA Template messages sent per day, unique by phone number by default',
    timesThatWA2: 'Changes in the number of WA Template messages sent per day, unique by the selected deduplication dimension',
    workflowTem: 'Workflow Template',
    wfDrawerTip: 'The latest available date can be up to two months from the current date.',
    realtime: 'Real-time',
    offline: 'Offline',
    sendNumTip: 'Number of requested messages to be sent, which does not represent the number of successful deliveries.',
    aveTip: 'Average number of requested message sends per unique phone number.',
    sendedNum: 'Messages Successfully Delivered',
    sendedNumTip: 'Number of messages successfully sent by the carrier. In cases where the message exceeds the character limit, it may be split into 2 messages, and will be counted as 2 messages.',
    sendSuc: 'Successfully sent messages ',
    sendedNumTip2: 'Number of times the operator successfully performs a sending after receiving a request',
    uniqSendSuc: 'Successful unique deliveries',
    uniqSendedNumTip: 'Number of times a request was successfully sent to an operator after de-emphasis by phone number.',
    uniqSendedNumTip2: 'Number of times a request was successfully sent to an operator after de-emphasis by the selected de-emphasis dimension.',
    clickRateTip: 'Percentage of clicks on short links within 7 days of sending, relative to the total number of successfully sent messages (counting multiple clicks as 1).',
    uniqClickRateTip: 'Percentage of clicks on short links within 7 days of sending, relative to the total number of unique successfully sent messages (counting multiple clicks as 1).',

    // 发布配置
    confirmTime: 'Please confirm that this workflow template requires a minimum runtime duration of',
    noMore62: 'The maximum runtime duration should not exceed 62 days.',
    minTime: 'Minimum Runtime Duration',
    // calendar
    delSelect: 'Delete Selected Items',
    batchAddHoliday: 'Batch Add Custom Holidays',
    uploadCustom: 'Import Custom Holidays',
    check: 'Validation',
    title2: 'Upload Completed File',
    fileTypeError: 'The file format is not correct, please try again.',
    max2M: 'Please upload a file smaller than 2MB.',
    pleaseUpload: 'Please upload a file first.',
    dlError: 'Download and View Failure Reasons',
    allData: 'Total Data',
    calendarUpload: 'Holidays have been uploaded.',
    calendar5s: 'The page will automatically close in 5 seconds.',
    delTip2: 'Custom holidays may be referenced in the workflow template. Please be cautious when deleting them.',

    labelLevel: 'Intention Priority',
    labelCombination: 'Intention Combination',
    effectCallDefinition: 'Definition of Effective Call',
    effectCallDefinition2: 'Dimension of Effective Call Definition',
    effectCallDefinition3: 'Minimum Effective Call Duration',
    labelLevelTip: 'Note: You can change intention priority by dragging, the earlier the sort, the higher the priority. Changes here will affect all historical de-duped intention data.',
    dimensionTip: 'Note: After selecting different de-duplication dimensions, you can view different de-duplication data on the data dashboard.',
    labelCombinationTip: 'Note: After combining different intentions, you can view the intention proportions in a combined manner on the dashboard.',
    effectCallDefinitionTip: 'Note: Please contact us to configure the effective call duration and effective period. Only the configuration result is shown here.',
    validCallToalTip: 'Total number of all effective connected calls. The definition of effective calls can be found in "Custom Settings".',
    validRepeatToalTip: 'Total number of effective connections after de-duplication by phone number.',
    validRepeatToalTip2: 'Total number of effective connections after de-emphasizing according to the selected de-emphasis dimensions',
    validCallRateTip: 'Ratio of total effective connections to total dials.',
    validRepeatRateTip: 'Ratio of de-duped effective connections to de-duped dialed list numbers.'
  },
  ca: {
    action: 'Action Parameters',
    list: 'List Parameters',
    system: 'System Parameters',
    diy: 'Custom Parameters',
    common: 'General Parameters',
    fun: 'Operational Parameters',
    funTip: 'Function Descriptions',
    bj1: 'From...till...',
    bj2: 'Is Empty',
    bj3: 'Is Not Empty',
    bj4: 'Holiday or Not',
    max: 'Maximum Value',
    min: 'Minimum Value'
  },
  desc: {
    date_sub_desc: 'Number of days can be obtained by subtracting data parameters.'
  },
  channel: {
    tableTitle: 'Template List',
    name: 'Template Name',
    content: 'Information',
    str: 'Number of Characters',
    num: 'Pieces of Information',
    channel: 'Channels',
    conventional: 'Regular Robots',
    diy: 'Customized IVR Robots',
    change: 'Change the Gender of the Voice',
    record: 'Gender of the Voice',
    speed: 'Broadcast Speed',
    contentTip:
      '①If there is a link in the SMS, it will be converted into a dedicated short link when sending. Then the clicks of users can be counted; ② If there is a {xxx} in the SMS, it is a variable in the template, which will differ according to the variables you uploaded.',
    strTip: ' This is an expected number of characters, which will vary depending on the actual content of the link or variable in the message.',
    sendTime: 'Send Time',
    templateName: 'SMS Template'
  },
  eventLabel: {
    label: 'Event Labels',
    attr: 'Label Attributes',
    drawerTitle: 'Event Label Description',
    all: 'All Information',
    more: 'More'
  },
  checkDetail: {
    ringTime: 'Ring Time',
    totalNumberCalls: 'Total Dialing Times',
    callHistory: 'Call Records',
    questionNumber: 'Serial Number of Question',
    problemDesc: 'Problem Description',
    topic: 'Question Type',
    whetherAnswer: 'Answered or Not',
    answer: 'Answer',
    variable: 'Variable',
    checkResults: 'Results of Verification',
    checkDialogue: 'View Dialogue',
    previousDetail: 'Previous Details',
    nextDetail: 'Next Details',
    history: 'History',
    know: 'Understood',
    clickDesc: 'Click to view the details and learn more about the call.',
    whether: 'Yes / No Questions',
    multiple: 'Multiple Choice',
    open: 'Open Questions'
  },
  report: {
    titleTip: '(Only the data generated after {name} is available for viewing.)',
    time: 'Time range',
    compared: 'Compares with',
    deduplication: 'Unique or Not',
    listNum: 'Total Number of Lists',
    connectNum: 'Number of Connected Calls',
    connectRate: 'Connection Rate',
    duration: 'Average Call Duration (s)',
    business: 'Business Data',
    robot: 'Robot Performance',
    turn: 'Connected or not',
    beforeOverdue: '~ T-1',
    todayOverdue: 'On Due Date',
    overdue: 'T+1 ~',
    labelRate: 'Label Trigger Rate',
    month: 'By Month',
    week: 'By Week',
    onWeek: 'Week {name}',
    unduplicated: 'Unique',
    duplicate: 'Total Calls',
    labelTip1: 'Total number of lists uploaded within screening time.',
    labelTip2: 'Total number of lists called within screening time.',
    labelTip3: 'Connection rate of lists called within screening time.',
    labelTip4: 'Average Call Duration of lists called within screening time.',
    type: 'Type'
  },
  version: {
    viewarchive: 'View Archive',
    archive: 'Archive',
    id: 'Version',
    description: 'Version Description',
    templateId: 'Template ID',
    save1: 'Iterate and Publish',
    save2: 'Publish as a New Version',
    save3: 'Enable this Version',
    save4: 'Not Enabled this Version',
    saveTip: 'When enabled, this version will replace the version currently being enabled.',
    draft: 'Drafts',
    time: 'Archival Time',
    re: 'Unarchive',
    user: 'Archived by',
    pdsQA: 'Auto QA',
    success: 'Enabled successfully.',
    resuccess: 'Unarchived successfully.',
    delsuccess: 'Archived successfully.',
    savesuccess: 'Saved successfully.',
    pop: 'This version has been released. A draft version will be created based on this version.',
    version: 'Version',
    listTime: 'List Upload Time'
  },
  experience: {
    robotNameTip: 'Please enter the Bot Name.',
    shareLog: 'Share History ',
    shareBatch: 'Share',
    playAudio: 'Play a Recording',
    experience: 'Try Now',
    share: 'Share Now',
    step1: 'Please fill in the basic info.',
    step2: 'Set the Senario and Bot',
    step3: 'Set Variable',
    step4: 'Completed',
    shareNmae: 'Share Name',
    language: 'Language',
    validity: 'Validity Period',
    callCountry: 'Dialing Country',
    shareTime: 'Share Time',
    zh: 'Chinese',
    en: 'English',
    ba: 'Bahasa Indonesia',
    copyLink: 'Copy the Link',
    qrcode: 'View QR Code',
    view: 'View Data',
    disable: 'Set as Invalid',
    linkLog: 'Link Browsing History',
    customerLog: 'Customer Experience Records',
    check: 'View Details',
    logTime: 'Browsing Time',
    browser: 'Browser',
    device: 'Device',
    city: 'City',
    isExperience: 'Try or Not',
    shareTitle: 'Share',
    dec: 'Bot Description ',
    enterShare: 'Confirm to Share',
    noVar: 'No variable required to be configured for this bot.',
    callNumber: 'Phone Number',
    waitCall: 'Please wait a moment, the call will be dialed soon.',
    reCall: 'Redial the Number',
    activeSuccess: 'Successfully set as invalid.',
    ruleName: 'Please enter the Share Name.',
    ruleLanguage: 'Please select the Language.',
    ruleTime: 'Please select the Validity Period.',
    ruleCounty: 'Please select the Dialing Country.',
    ruleDesc: 'Please enter the Bot Description.',
    fail: 'Current link is no longer valid, please contact the sharer.',
    sceneName: 'Scenario Name',
    sceneDesc: 'Scenario Description ',
    canModify: 'Modifiable by Customer',
    calltitle: 'Fill in information',
    successTitle: 'Submitted Successfully.',
    wait: 'Please wait.',
    waitNext: 'The call will be dialed soon.',
    cut: 'Split up the bots of the scenario',
    cutTip: 'If you need to combine multiple bots into one scenario to share, please drag-and-drop the bots to the same scenario.',
    codeTip2: 'The QR code will expire on {time}.',
    codeTip1: 'Scan to Try the Intelligent VoiceBot',
    downCode: 'Download QR Code',
    tips: 'Are you sure to disable it?',
    tempDesc: 'Description Template',
    sceneRepeat: 'The Scenario Name already exists.',
    callTime: 'Dialing Time',
    otherRob: 'Other Bots',
    failTime: 'Expiration Time',
    gender: 'Voice'
  },
  // 私有化版本相关功能
  v_privatization: {
    templateContent: 'Template Contents',
    insertUrl: 'Insert Target URL',
    templatePlaceholder: 'Please enter the template name.',
    templateContentPlaceholder: 'Please enter the template content.',
    channelPlaceholder: 'Please select the sending channel.',
    SMSTemplate: 'SMS Template',
    WhatsAppTemplate: 'WhatsApp Template',
    createSMSTemplate: 'New SMS Template',
    editSMSTemplate: 'Edit SMS Template',
    createWhatsAppTemplate: 'New WhatsApp Template',
    editWhatsAppTemplate: 'Edit WhatsApp Template',
    SMSTip:
      'Description: After entering the Original URL, click "Insert Target URL" to insert the link into the SMS when sending. The Target URL is the short link sent to the contact, through which clicks of the link are counted. Word counts and number of SMS messages are estimated results. For acurate results, please test it by yourself.',
    WhatsAPPTip:
      'Note: After entering the Original URL, click "Insert Target URL" to insert the link into the message when sending. The Target URL is the short link sent to the contact, through which clicks of the link are counted. Word counts and number of SMS messages are estimated results. For acurate results, please test it by yourself.',
    hangUpMessage: 'Hang-up Message',
    hangUpMessageAdd: 'New Hang-up Message',
    hangUpMessageEdit: 'Edit Hang-up Message',
    hangUpMessageTip: 'If the Multi-round Message Sending Strategy is enabled, then in this round, messages will not be sent to the contacts that will be called at next round.',
    callResult: 'Call Result',
    messageType: 'Message Type',
    messageTemplate: 'Message Template',
    messageChannel: 'Message Channel',
    messageNumber: 'Number of Messages',
    messageTip:
      "① Users' clicks of the short link in the SMS will be counted; ② The {xxx} is a variable in the SMS template, for which, various texts will be sent to different contacts based on the contents uploaded.",
    channel: 'Channels',
    platformPlaceholder: 'Please select a Platform',
    addMessage: 'New Message Template',
    activeStatusTip: 'Are you sure you want to enable the template?',
    inactiveStatusTip: 'Are you sure you want to disable the template?',
    activeHangUpStatusTip: 'Are you sure you want to enable the hang-up message?',
    inactiveHangUpStatusTip: 'Are you sure you want to disable the hang-up message?',
    operateSuccess: 'Succeed',
    licenseValidityPeriod: 'License Validity Period',
    maxCallConcurrency: 'Max Call Concurrency',
    LicenseTip: 'License Expiration Reminder',
    licenseWillExpired: 'Reminder: Your License will expire in {day} day(s), after which you will no longer be able to access. Please contact AIRUDDER to renew the license in time.',
    licenseExpired: 'Reminder: Your License has expired for {expired} day(s). You will not be able to use it unless you renew it in {last} days. Please contact AIRUDDER to renew the license. ',
    licenseInvalid: 'The license has been expired. Please renew it.'
  },
  calendar: {
    title: 'Calendar Management',
    lab1: 'Holiday List',
    lab2: 'Calendar Distribution',
    type: 'Classification',
    dayName: 'Holiday',
    addDay: 'Add Custom Holiday',
    day1: 'Working Day',
    day2: 'Non-working Day',
    day3: 'Legal Holiday',
    day4: 'Custom Holiday',
    tip: "Judgment logic: The list will be evaluated when it enters this node, or at 05:00 hours daily based on the account's time zone. If it is not eligible for release, it will be reevaluated at 05:00 hours the next day. This process will continue until the list meets the release conditions for the current day, enabling it to proceed to the subsequent steps.",
    r1: 'Use the original Bot',
    r2: 'Select a Bot'
  },
  inbound: {
    screeningConditions: 'Filters',
    talkedByRobots: 'Total Calls',
    talkingByRobots: 'Robot Calls in Progress',
    stRate: 'Agent Reception Rate',
    stTip: 'successful transfers to human agents / total calls',
    raTalkTime: 'Average Robot Call Duration',
    raTalkRounds: 'Average Robot Interaction Rounds',
    tbAgents: 'Agent Calls',
    tbTip: 'successful transfers to human agents',
    tbAgents2: 'Agent Calls in Progress',
    tttRate: 'Attempted Transfer Rate',
    tttTip: 'attempted transfers to human agents / total calls',
    tatTime: 'Total Average Call Duration',
    tickets: 'Tickets Created',
    graphics: 'Table',
    prceProcess: 'Bot Call Percentage by Processes',
    calls: 'Talked Calls',
    rate: 'Percentage',
    allProcess: 'All Processes',
    rlDistribution: 'Intention Distribution',
    dtReason: 'Reason Distribution for Agent Transfer',
    dtNodes: 'Transfer Node Distribution',
    kwnlPoint: 'Knowledge Hit Rate',
    hitValid: 'Valid Knowledge Hits',
    useRate: 'Utilization Rate of Knowledge',
    knRoundNum: 'Dialog Rounds Hit the Knowledge',
    allRoundNum: 'Total Conversation Rounds',
    validPer: 'Percentage of Valid Knowledge',
    top10: 'Top10 Popular Knowledge',
    top20: 'Top20 Least Popular Knowledge',
    knName: 'Knowledge',
    mainProcess: 'Main Process',
    hotline: 'Hotline',
    inbound: 'Inbound',
    inAndOut: 'Inbound+Outbound',
    userSatis: 'CSAT',
    star1: '1 point',
    star2: '2 points',
    star3: '3 points',
    star4: '4 points',
    star5: '5 points',
    satisRate: 'CSAT Score',
    userNum: 'Contacts',
    rotTip2:
      'Percentage of valid calls where the contact did not call twice. This statistic are the bot first contact resolution rate per calendar day. If the selected time period exceeds one day, the numerator is the sum of effective calls without a second call for each day within the selected time period',
    rotTip: 'The ratio of valid calls without a second call on the same day to the total number of valid calls',
    ctuTip: 'The number of unique callers based on the incoming phone numbers received',
    etuTip: 'The total number of unique users, based on their incoming phone numbers, who had at least one valid interaction with the robot during the calls.',
    totalEffectCallNum: 'Total Active Calls',
    noSecondCallNum: 'Effective Call of Contacts without Second Incoming Calls',
    oneTimeRate: 'First Contact Resolution Rate',
    taiTip: 'successful transfers to human agents / attempted transfers to human agents',
    rjTip: 'The percentage of evaluated calls out of the total calls where customer satisfaction evaluations were triggered',
    reCallNum: 'Number of Repeated Calls',
    reCNTip: 'The number of calls that are not the first call per day, is the "Total Calls" - "Incoming Contacts".',
    rcrTip: 'Percentage of repeated calls/total calls',
    taTip: 'Percentage of calls successfully transferred to agent out of calls attempting to transfer to agent',
    ctTip: 'The number of incoming calls de-duplicated by inbound number.',
    euTip: 'The number of effective calls de-duplicated by inbound numbers.',
    rcTip: 'Percentage of contacts with multiple incoming calls',
    rcrTip2: 'Percentage of repeat inbound calls as a proportion of total calls per natural day. If the filtered time period exceeds 1 day, the percentage represents a daily average value.',
    orTip: 'Percentage of valid calls where the contact did not call twice',
    orTip2: 'Percentage of valid calls where the contact did not call twice(This is T-1 day data, which represents the first contact resolution rate for each calendar day.）',
    oneRateTip: 'This is T-1 day data',
    realtimeData: 'Real-time Data',
    offlineData: 'Offline Data',
    robotSatis: 'Robot Satisfaction Rate',
    rsTip: 'The percentage of calls rated as "satisfied" among all evaluated calls',
    robotSatisTip: 'The percentage of calls scoring 3 or higher in all rated calls.',
    robotJudgeNum: 'Number of Bot Evaluations',
    robotSatisNum: 'Number of Bot Satisfactions',
    thisDayNoBack: 'Valid Calls without a Second Call Attempt on the Same Day',
    thisDayMax: 'The Maximum Concurrency for the Day',
    showAndDlField: 'The Fields to Display and Download',
    untriggered: 'Untriggered',
    unrated: 'Unrated',
    robotSatisRate: 'Bot Satisfaction Score',
    indicators: 'Indicators',
    labelPriority: 'Intention Priority',
    dlData: 'Download',
    offlineTip: 'The data for this module is generated with a one-day delay (T+1). Therefore, if you select the current day as the time period, no data will be displayed.',
    slotTip1: 'Note: NER slots are configured in the robot flow. All robot slots are shown here.',
    slotTip2: '1. Please set whether to display a slot when it is hit or not according to your need. If you check "Display", the hit slot and slot value will be displayed in the call details;',
    slotTip3: '2. Please set whether a certain slot can be used as a filter item according to your needs;',
    slotTip4:
      '3. Please set whether a certain slot can be used as the Excel table header of the download list after it is hit according to your needs, and other slots and slot values that are not set will be uniformly put under the NER slots table header field.',
    diffTime: 'Comparison Time',
    minValidInteractives: 'Human-Bot Rounds',
    minValidInteractives2: 'Min. Human-Bot Rounds',
    robotTimeLeast: 'Min. Bot Valid Call Duration',
    effectCallSetTip: 'Note: Switch the definition of effective calls and view it in the data dashboard.',
    orders: 'Total Tickets',
    xjqsOrders1: 'Total Fake Receipts',
    xjqsOrders2: 'Daily Unique Fake Receipts',
    xjqsOrders3: 'Total Unique Fake Receipts',
    hangAINum: 'AI Hangup Calls',
    hangUserNum: 'User Hangup Calls',
    hangeAgentNum: 'Agent Hangup Calls',
    tbAgentsTip1: 'Number of Calls in Progress with Bot',
    tbAgentsTip2: 'Number of Calls in Progress with Agent',
    callTimeTip: `The current period and previous period for calculating period-over-period data are determined by the selected time range, whether it's a single day or a multi-day range. For example, if "Today" is selected, the current period is today and the previous period is yesterday. If "Last 3 Days" is selected, the current period is the last 3 days and the previous period is the 3 days before that.`,
    tbAgentsTip: 'Calls Successfully Transferred to Agents',
    stRateTip: 'Calls Successfully Transferred to Agents/ Total Calls',
    tttRateTip: 'Attempted Transferred Calls/ Total Calls',
    toArtiRateTip: 'Calls Successfully Transferred to Agents/Attempted Transferred Calls ',
    attAgentNumTip: 'Number of Attempted Transferred Calls out of Total Calls',
    validCallNumTip: 'See "Custom Settings" for the definition of Effective Calls.',
    tatTimeTip: 'Average call duration for the entire call, including bot and agent portions.',
    raTalkTimeTip: 'Avg Call Duration for Bot Portion',
    agentAvgDurationTip: 'Average Call Duration for Agent Portion',
    validCallDesTip: 'Daily Distribution of Total Calls and Effective Calls (see Effective Call definition in "Custom Settings")',
    everydayMaxTip: 'Daily Peak Concurrency at the Minute Level (T-1 data, unavailable for current day)',
    raTalkRoundsTip: 'Avg Number of Bot-User Interaction Rounds',
    robotJudgeRateTip: 'The percentage of rated calls out of all calls with triggered satisfaction evaluations.',
    robotSatisAvgScoreTip: 'The average satisfaction score for all calls (calculated from calls with actual ratings).',
    robotOneTimeRateTip: `The daily percentage of effective calls with no subsequent calls from the user; for a period exceeding one day, it's the sum of daily effective calls without a second call. See "Custom Settings" for the definition of effective calls.`,
    robotOneTimeRateTip2: `The daily percentage of effective calls with no subsequent calls from the user, as defined in "Custom Settings" (T-1 data, unavailable for current day).`,
    prceProcessTip: 'The proportion of call volume for each main process within the total call volume.',
    noCurDaySeeTip: 'T-1 data, unavailable for current day.',
    intentAccuracyTip: 'Bot intent recognition accuracy (T-1 data, unavailable for current day).',
    newUserNumTip: 'Number of First-Time Callers',
    oldUserNumTip: 'Number of Repeat Callers',
    validPerTip: 'Number and percentage of effective knowledge points hit out of all knowledge points, indicating the efficacy of the knowledge base design in addressing real user queries.',
    kwnlPointTip: `Daily distribution of knowledge hit rounds, total rounds, and their ratio, indicating the knowledge base's coverage of user queries.`,
    top10_tip: 'The top 10 most queried knowledge points are listed in descending order of frequency of hits (dialogue turns).',
    top20_tip: 'List of Never-Hit Knowledge Points',
    minValidRoundTip: 'During the human-bot conversation, the user spoke at least once, including using the phone keypad.',
    isFalseSign: 'Fakely Signed or Not',
    falseSignOD: 'Fake Receipts',
    realCall: 'Real-time Call',
    vaildUser: 'Valid User',
    ticketType: 'Ticket Type'
  },
  chatbot: {
    reason: 'Reason',
    indicator: 'Insight',
    graphics: 'Data Visualization',
    social: 'Social Media',
    allSocial: 'All Social Media',
    allCountry: 'All Country',
    sessionData: 'Session Data',
    resTime: 'Response Time',
    today: 'Today',
    yesterday: 'Yesterday',
    robotSessionNum: 'Robot sessions',
    likeFWRate: 'Agent Satisfaction Score',
    satisRate: 'Satisfaction Score',
    robotEnd: 'Ended by Bot',
    botQueueTimeout: 'Bot Queue Timeout',
    userEnd: 'Ended by User',
    agentEnd: 'Ended by Agents',
    robotChatCondition: 'Bot Sessions',
    sessionEndReason: 'Reasons for Ending',
    intentionDistribution: 'Triggered Service Distribution',
    identifyDistribution: 'Recognition Distribution',
    knowledgeBase: 'Knowledge Base',
    intention: 'Intention Label',
    chat: 'Chitchat',
    unrecognized: 'Unrecognized',
    robotCondition: 'Robot Recognition Distribution',
    top10: 'Top 10 Popular Knowledge',
    words: 'Script',
    knowledgePoints: 'Knowledge',
    triggerRate: 'Trigger Times/Ratio',
    star1: '1 Star',
    starVal: '{num} Stars',
    userNum: 'Users',
    sessionNum: 'Sessions',
    repeatRate: 'Multi-Session Rate',
    repeatRate2: "Today's Multi-Session Rate",
    userNews: "Users' Messages",
    robotTimes: 'Bot Response Time',
    robotBFNum: 'Bot Concurrency',
    artificialNum: 'Chats Transferred to Agent',
    robotWaitNum: 'Chats in Bot Queue',
    artificialWaitNum: 'Chats in Agent Queue',
    artificialCalls: 'Agent Response Time',
    callsAvg: 'Average Response Time',
    sessionAvg: 'Average Session Duration',
    robotSessionAvg: 'Bot Average Session Duration',
    artificialRate: 'Bot-to-Agent Rate',
    robotEndNum: 'Sessions End by Bot',
    userEndNum: 'Sessions End by User',
    artificialEndNum: 'Sessions End by Agent',
    roundAvg: 'Average Round of Conversation ',
    robotLikes: 'Bot Satisfaction Score',
    JSRate: 'Unrecognized Rate',
    knowledgeNum: 'Knowledge',
    intentionNum: 'Intention Labels',
    chatNum: 'Chitchat',
    unrecognizedNum: 'Unrecognized',
    recognizedNum: 'Direct Recognition Rate',
    recommendRate: 'Recommended Question Trigger Rate',
    vsday: 'Previous 1 day',
    vsday7: 'Previous 7 days',
    detailExport: 'Export Details',
    total: 'Totals',
    date: 'Date',
    country: 'Country',
    channel: 'Channel',
    download: 'Download',
    userLikes: 'User Satisfaction',
    coreData: 'Core Business Data',
    likeRate: 'Satisfaction Rate',
    evaluateRate: 'Evaluation Rate',
    serverLikeRate: 'Service Satisfaction Rate',
    robotLikeRate: 'Bot Satisfaction Rate',
    robotEvaluateRate: 'Bot Evaluation Rate',
    artificialSuccessRate: 'Success Rate of Bot to Agent',
    serverEvaluateRate: 'Service Evaluation Rate',
    todayMaxBFNum: 'Maximum Daily Concurrency ',
    likeNum: 'Satisfied',
    firstSolutionRate: 'First Contact Resolution Rate',
    silde_first_rate: 'Overall', // 未翻译
    robot_silde_first_rate: 'Bot',
    agent_silde_first_rate: 'Agent',
    artificialOkSessions: 'Chats Successfully Transferred',
    todayZXYDNum: 'Order Inquiries of the Day',
    ZXYDNum24: 'Orders Inquiries without Second Inquiries in 24h',
    userLikeNum: 'Satisfied Users',
    evalUsers: 'Evaluated Users',
    robotEvaluates: 'Evaluations on Robots',
    robotLikeNum: 'Satisfied Evaluations on Robots',
    userServerEvaluates: 'Evaluations on Agent Service',
    userServerEvaluateRate: 'Evaluation Rate of Agent Service',
    userServerLikeRate: 'Satisfaction Rate of Agent Service',
    userServerLikes: 'Satisfied Evaluations on Agent Service',
    artificialFailNum: 'Sessions Failed to Transfer to Agent',
    artificialFailEvaluates: 'Evaluations on Failed Transfer',
    artificialFailLikes: 'Satisfied Evaluations on Failed Transfer',
    artificialFailEvaluateRate: 'Evaluation Rate of Failed Transfer',
    artificialLikeRate: 'Satisfaction Rate of Agent Transfer',
    artificialFailLikeRate: 'Satisfaction Rate of Failed Transfer',
    all: 'All',
    likeRateAnalysis: 'CSAT Analysis',
    serverEffect: 'Service Effect',
    dislikeDistribution: 'Distribution of Reasons for Dissatisfaction',
    sessionType: 'Chat Type',
    robotSession: 'Bot Chats',
    artificialSuccess: 'Successfully Transferred ',
    artificialFail: 'Failed to Transfer ',
    artificialSession: 'Chats Transferred to Agent',
    botServerSession: 'Sessions Served by Bot',
    artificialOkSession: 'Sessions Successfully Transferred',
    artificialFailSession: 'Sessions Failed to Transfer',
    evaluates: 'Evaluations',
    channelMerge: 'Channel Aggregation',
    current_users_total: 'Active Chats',
    current_robot_wait: 'Active Chats in Bot Queue',
    current_agent_sessions: 'Active Chats Handled by Agent',
    current_robot_sessions: 'Active Chats Handled by Bot',
    current_agent_wait_sessions: 'Active Chats in Agent Queue',
    users: 'Users',
    sessions: 'Sessions',
    rr_income: "Today's Multi-Session Rate",
    user_messages: "Users' Messages",
    robot_res_time: 'Bot Response Time',
    transfers: 'Chats Transferred to Agent',
    // transfer_rate: 'Bot-to-Agent Rate',
    // transfers_succeed_rate: 'Success Rate of Bot to Agent',
    avg_sessions_time: 'Average Session Duration',
    avg_robot_time: 'Average Bot Session Duration',
    avg_agent_time: 'Average Agent Session Duration',
    // avg_trans_time: 'Average Transfer Time',
    max_qps: 'Maximum Daily Concurrency',
    Knowledge: 'Knowledge Base',
    All: 'Intent',
    NoRecognize: 'Unrecognized ',
    user_close: 'Ended by User',
    robot_close: 'Ended by Bot',
    agent_close: 'Ended by Agent',
    ascending: 'Ascending',
    descending: 'Descending',
    etip1: 'Drag and drop the indicators you choose to the related areas',
    etip2: 'Reason for Closed Sessions',
    etip3: 'Indicators have been added.',
    etip4: 'No other available indicators temporarily.',
    etip5: 'Graphics have been added.',
    etip6: 'No other available graphics temporarily.',
    etip7: 'If you leave before saving, the data will be lost. Do you wish to save the changes?',
    title1: 'Real-Time Activity',
    title2: 'Cumulative Indicators',
    title3: 'Graphics',
    title4: 'Bot Intent Recognition',
    title5: 'Reason for Closed Sessions',
    title6: 'Trends',
    title7: 'Top Flows',
    botSessionNum: 'Bot Sessions',
    transfer_rate: 'Bot-to-Agent Transfer Rate',
    transfers_succeed_rate: 'Success Rate of Bot-to-Agent Transfer',
    avg_trans_time: 'Average Agent Transfer Time',
    agentSessions: 'Agent Sessions',
    csat1: '1 Star',
    csat2: '2 Star',
    csat3: '3 Star',
    csat4: '4 Star',
    csat5: '5 Star',
    res_time: 'Overall Response Time',
    agent_res_time: 'Agent Response Time',
    bot_res_time: 'Bot Response Time',
    session_time: 'Overall Session Duration',
    agent_session_time: 'Agent Session Duration',
    robot_session_time: 'Bot Session Duration',
    totals: 'Total',
    marketing: 'Marketing',
    service: 'Service',
    utility: 'Utility',
    authentication: 'Authentication',
    contact_rate: 'Connection Rate',
    false_signature: 'Total False Delivery Receipt Count',
    dis_day_false_signature: 'Deduplicated False Delivery Receipt Count By Day',
    titleFalseSignature: 'False Delivery Receipt Count Distribution',
    titleDistribution: 'Ticket Type Distribution',
    all_data: 'Total Tickets',
    overview: 'Overview',
    insight: 'Business Insights',
    fake_way_bill_nos: 'False Delivery Receipt No.',
    time: 'Time',
    isFake_way_bill_nos: 'False Delivery Receipt or Not',
    robotSessionNumisg: 'Bot Sessions',
    artificialNumisg: 'Agent Sessions',
    artificialNumTitle: 'Sessions Transferred to Agent',
    robotWaitNumisg: 'Sessions in Bot Queue',
    artificialOkSessionsTitle: 'Sessions Successfully Transferred to Agent',

    historical: {
      title: 'Overall Metrics',
      title1: 'User Activity Over Time ',
      title2: 'Activity Trend',
      title3: "Today's Multi-Session Rate",
      title4: 'Sessions Trend By Type',
      title5: 'Bot-to-Agent Transfer Rate',
      title6: 'Average Response Time',
      title7: 'Average Session Duration',
      title8: 'Reason for Closed Sessions',
      title9: 'First Contact Resolution Rate',
      title10: 'Maximum Daily Concurrency',
      title11: 'Service Analysis',
      title12: 'Service Flows Distribution',
      title13: 'Service Effect',
      title14: 'User Satisfaction',
      title15: 'Reasons for Dissatisfaction',
      title16: 'Key Dissatisfaction Flows Distribution',
      title17: 'Reasons for Agent Transfer',
      title18: 'WABA Fee Calculation Module',
      title19: 'WABA Conversation Count',
      titleContactRate: 'Connection Rate',
      overall: 'Overall',
      bot: 'Bot',
      agent: 'Agent',
      tip: {
        title1:
          'User activity showing the most active hours during the queried period on an average basis<br/>Users: Number of distinct incoming users<br/>Sessions: Number of sessions initiated by users',
        title2: 'Users: Number of distinct incoming users<br/>Sessions: Number of sessions initiated by users',
        title3: 'Number of sessions initiated by one user who initiated multiple ones during the day/ Total number of all sessions',
        title4:
          'Total sessions: Includes all sessions<br/>Bot sessions: Sessions exclusively handled by bot (no agent handoff)<br/>Agent sessions: Sessions where bot initiated agent handoff, including both successful and unsuccessful handoffs<br/>Failed to Transfer: Sessions where bot initiated agent handoff but was unsuccessful',
        title5:
          'Bot-to-Agent Transfer Rate：Number of sessions transferred to agent/number of sessions<br/>Success Rate of Bot-to-Agent Transfer： Number of successfully transferred sessions / Number of sessions transferred to agent',
        title6:
          'Overall Response Time: Average runtime for a single reply for overall session<br/>Bot Response Time: Average runtime for a single reply for session served by bot<br/>Agent Response Time: Average runtime for a single reply for session served by agent',
        title7:
          'Overall Session Duration: Average total duration between user and bot/agent (if there is an agent handoff)<br/>Bot Session Duration: Average duration between user and bot for bot sessions without agent handoff<br/>Agent Session Duration: Average duration between user and agent for agent sessions where agent handoff was initiated',
        title8:
          'Ended by Bot: Sessions solely handled by bot (no agent handoff)<br/>Failed to Transfer: Sessions ended due to unsuccessful agent handoff<br/>Ended by Agents Sessions ended by agent after successful handoff<br/>Ended by User: Currently not supported<br/>Bot Queue Timeout: Timeout due to bot concurrency restrictions',
        title9: 'The proportion of waybills that have not been repeatedly queried within 24 hours after the first query',
        title10: 'The maximum concurrency of the bot in the day<br/>The concurrency period is defined as the period when the user initiates the session up till agent handoff or when the session ends',
        title11: '',
        title12: 'Distribution of Bot Service Flows',
        title13: 'Analysis of service effectiveness, including evaluation rate and satisfaction rate',
        title14: '',
        title15: 'Reasons indicated by users for dissatisfied sessions',
        title16: 'Trend distribution of key flows where user indicated dissatisfaction',
        title17: 'Flows that triggered Agent Transfer',
        titleContactRate: ''
      }
    },

    story: {
      story_PlaceOrder: 'Parcel Sending',
      story_DeliveryAsk: 'Parcel Inspection',
      story_Package_returned: 'Parcel Return',
      story_Change_Information: 'Modify Info',
      story_AskShippingCost2: 'Check Shipping Fee',
      sotry_AskEstimatedTimeBeforeDelivery: 'Check Estimated Time',
      story_AskBranch: 'Check Branches',
      story_AskDelivery_Range: 'Check Delivery Area',
      story_PackageIssues: 'Parcel Queries',
      story_AskFranchise: 'Franchising Queries',
      story_TransferArtificial: 'Customer Service',
      story_Complaint: 'Complaints'
    },
    story2: {
      story_AskEstimatedTimeBeforeDelivery: 'Check Delivery Time',
      story_entrance: 'Menu',
      all_TransferArtificial: 'Customer Service',
      story_AskIFHelp: 'Require Other Services',
      story_IfSolved: 'Problem Resolved',
      story_AskJob: 'Job Request',
      story_ConfirmIntent: 'Confirm Service Request (Job/Franchise)',
      story_InquiryServices: 'Confirm Inquiry (Branches/Delivery Area)',
      story_PackageClaim: 'Package Claim',
      story_ServiceSelection: 'Service Selection (Parcel Inspection/Agent Transfer)',
      story_PlaceOrder: 'Parcel Sending',
      story_Package_returned: 'Parcel Return',
      story_Change_Information: 'Modify Info',
      story_AskShippingCost2: 'Check Shipping Fee',
      story_AskBranch: 'Check Branches',
      story_AskDelivery_Range: 'Check Delivery Area',
      story_PackageIssues: 'Parcel Queries',
      story_AskFranchise: 'Franchising Queries',
      story_Complaint: 'Complaints',
      story_OtherService: 'Other Service',
      story_Create_Order: 'Create Ticket',
      story_Create_Order_POD: 'Create Ticket',
      story_DeliveryAsk: 'Parcel Inspection',
      story_Query_another_logistic: 'Parcel Inspection',
      story_TransferArtificial: 'Customer Service',
      story_Transfer: 'Customer Service'
    },
    userID: 'User ID',
    userName: 'User Nickname',
    localTime: 'Local Time',
    sessionStartTime: 'Session Start Time',
    robotServiceTime: 'Robot Service Time',
    agentServiceTime: 'Agent Service Time',
    botServiceTime: 'Bot Session Duration',
    agentSessionDuration: 'Agent Session Duration',
    botService: 'Bot Service',
    agentSession: 'Agent Service',
    waybill: 'Valid Order No.',
    sessionEndTime: 'Session End Time',
    sessionDur: 'Session Duration',
    serverStatus: 'Service Status',
    robotServer: 'Robot Service',
    userServer: 'Customer Service',
    noLikeReason: 'Reasons for Dissatisfaction',
    sessionDetail: 'Conversation Details',
    prevOne: 'Previous',
    nextOne: 'Next',
    cannelTitle: 'Manage the different messaging channels used to communicate with your contacts.',
    noChannel: 'You have no channels',
    addCannnel: 'New Channel',
    delete: 'Delete',
    edit: 'Edit',
    detail: 'Details',
    duplicate: 'Duplicate',
    action: 'Operations',
    addTime: 'Create Time',
    updateTime: 'Update Time',
    updater: 'Updater',
    accountName: 'Account Name',
    dialogueLink: 'Dialogue Link',
    last: 'Previous',
    next: 'Next',
    next2: 'Already had, Next',
    authorize: 'Authorize Account',
    stepVal: 'Step {num}',
    viberPanel: 'Viber Bot Panel',
    almost: 'Almost There',
    addBind: 'New Binding',
    editBind: 'Edit Binding',
    effectChannel: 'Effective Channel',
    robotId: 'Robot ID',
    versionId: 'Version ID',
    channelName: 'Channel Name',
    channelId: 'Channel ID',
    updateAccount: 'Update Account',
    seeRecord: 'Check Records',
    save: 'Save',
    cancel: 'Cancel',
    submit: 'Submit',
    remark: 'Remarks',
    facebookBtn: 'Link Facebook',
    connectChannel: 'Connect your Channel',
    newInf: 'New Info',
    editInf: 'Edit Info',
    name: 'Name',
    company: 'Company',
    proxy: 'Proxy',
    reqName: 'Request Name',
    tmplName: 'Template Name',
    saveDraft: 'Save as draft',
    saveSubmit: 'Save and submit',
    wbTmplStatus: {
      draft: 'Draft',
      rejected: 'Rejected',
      submitted: 'Submitted',
      paused: 'Paused',
      disabled: 'Disabled',
      approved: 'Approved'
    },
    unknown: 'Unknown',
    broadcastList: 'Broadcast List',
    broadcastName: 'Broadcast Name',
    sendAccount: 'Send by',
    broadcastTmpl: 'Broadcast Template',
    newBroadcast: 'New Broadcast',
    broadcastDetail: 'Broadcast Details',
    broadcastData: 'Broadcast Data',
    taskList: 'Task List',
    tmplInf: 'Template Information',
    copyTask: 'Copy Task',
    broadcastTime: 'Broadcast Time',
    selectTmpl: 'Select Template',
    upContacts: 'Upload List',
    setTime: 'Set Time',
    language: 'Language',
    category: 'Category',
    subcate: 'Type',
    styletype: 'Type',
    taskStatus: {
      failed: 'Failed',
      wait: 'Waiting',
      sending: 'Sending',
      sent: 'Sent',
      delivery: 'Delivered',
      read: 'Read',
      replied: 'Replied'
    },
    taskNum: 'Recipients',
    sentNum: 'Messages Sent ',
    deliveredNum: 'Messages Delivered ',
    readNum: 'Messages Read ',
    replies: 'Replies',
    failNum: 'Failure',
    deliveredRate: 'Delivered Rate',
    readRate: 'Read Rate',
    replyRate: 'Reply Rate',
    sendNow: 'Send it now',
    sendSchedule: 'Schedule for a specific time',
    sendTime: 'Send Time',
    account: 'Account',
    downloadTmpl: 'Download Template',
    reupload: 'Reupload',
    sendResults: 'Sending Result',
    broadcastStatus: 'Broadcast Status',
    userAccount: 'User Account',
    userOptOut: 'User Opt-out',
    batchAdd: 'Batch Add',
    seatMark: 'Agent Remark',
    addNameLs: 'Add List',
    moreDetails: 'View More',
    optOutStartTime: 'Opt-out Start Time',
    optOutEndTime: 'Opt-out End Time',
    remove: 'Remove',
    quality: 'Quality Rating',
    currentLimit: 'Messaging Limit',
    selectLocation: 'Select Location',
    selectCategory: 'Select Category',
    locationName: 'Location Name',
    locationAddress: 'Location Address',
    longitude: 'Longitude',
    latitude: 'Latitude',
    assigned_agent: 'Assigned Agent',
    tip: {
      userNum: 'Number of distinct incoming users',
      sessionNum: 'Number of sessions initiated by users',
      repeatRate: 'Number of sessions initiated by one user who initiated multiple ones during the day/ Total number of all sessions',
      userNews: 'Number of messages sent by users',
      robotTimes: 'Sessions served by the bot, average runtime for a single reply',
      robotBFNum: 'Number of customers currently in session with the bot',
      artificialNum: 'Number of sessions transferred from bot to human',
      artificialRate: 'Number of sessions transferred to agent/number of sessions',
      robotWaitNum: 'Number of sessions waiting for bot',
      artificialWaitNum: 'Number of sessions waiting for agent',
      artificialCalls: 'Average single reply runtime for sessions served by agent',
      callsAvg: 'Average single reply runtime',
      sessionAvg: 'Average number of minutes for all sessions',
      robotEndNum: 'Sessions ended by bot',
      userEndNum: 'Sessions ended by user (Button/Strategy)',
      artificialEndNum: 'Sessions ended by agent',
      roundAvg: 'Average rounds of conversations between bot and user per session',
      robotLikes: 'Satisfaction score of users served only by bots',
      JSRate: 'Rate of user messages not recognized by the bot',
      recognizedNum: 'Number of messages where the bot recognized user intention',
      recommendRate: "Number of messages triggered recommended questions to clarify users' intentions",
      knowledgeNum: 'Number of bot replies that hit the knowledge base',
      intentionNum: 'Number of bot replies that hit intention recognition',
      chatNum: 'Number of bot replies that hit chitchat',
      unrecognizedNum: 'Number of messages sent by users not recognized by the robot',
      robotSessionAvg: 'The average session duration served by bots',
      firstSolutionRate: 'Percentage of queried orders with no duplicate sessions within 24 hours',
      todayMaxBFNum: 'Maximum Concurrency of Bots on the queried date',
      serverLikeRate: 'Satisfied Sessions / Evaluated Sessions of All Sessions',
      serverEvaluateRate: 'Evaluated Sessions / All Sessions',
      artificialSuccessRate: 'Number of successfully transferred sessions / Number of sessions transferred to agent',
      robotLikeRate: 'Satisfied Sessions / Evaluated Sessions among Bot-served Sessions',
      artificialLikeRate: 'Satisfied Sessions / Evaluated Sessions among Bot-to-Agent Sessions',
      userServerLikeRate: 'Satisfied Sessions / Evaluated Sessions among Agent-served Sessions',
      artificialFailLikeRate: 'Satisfied/evaluated sessions among those failed to be transferred to the Agent',
      contact_rate: 'Number of users successfully connected to bot / Total number of incoming users',
      channelMerge: 'After switched on, aggregated data for all channels will be displayed, otherwise, detailed data for each channel will be displayed.',
      plsDayVal: 'Up to {num} searchable days',
      plsFutureDayVal: 'Please select the time in the next {num} day(s)',
      noChannel: 'You can connect all your business messaging accounts in oneplace. We call these accounts channels. Let’s connect a channel.',
      facebookTitle: 'We need some permissions to manage your homepage messages to receive and reply to the messages and comments on Messenger.',
      facebookStep1: "Due to Facebook's blocking rules, please authorize and bind on the computer you regularly use to log into your Facebook account.",
      facebookStep1_des: 'Before authorization, please make sure you are the administrator of your Facebook fan page.',
      facebookStep2: 'If you receive an error message, please check if your network is working properly, refresh the page and try again.',
      facebookStep3: 'Login to your Facebook account and select the Fan Page you want to authorize.',
      insTitle: 'Please make sure that you have the Professional Instagram account.',
      insStep1_1: 'Please switch your Instagram account to Professional account before authorizing AI Rudder.',
      insStep1_2: 'If you need any help, please refer to:',
      insStep1_3: 'Switch to Professional account in Instagram',
      whatsappStep1: 'Phone number never registered on WhatsApp that can receive SMS or calls',
      whatsappStep2: 'Verified Facebook Business Manager',
      lineTitle: "Please create Line's Messaging API channel under the same Provides, and then provide the following information to add a Line account.",
      botTokenProvide: 'Please provide the Bot Token obtained at {name} to complete the authorization.',
      authorizeSuccess: 'Authorization successful',
      authorizeFail: 'Authorization failed',
      delChannel: 'If you revoke the authorization of this channel, you will no longer be able to interact with your contacts through this channel. Are you sure you want to revoke the authorization?',
      repeatChannel: 'The account has already been authorized, please select another account.',
      plsTelMe: 'Please contact us for help',
      plsScopeFacebook: 'Please authorize the Facebook account',
      upload: 'Allow {types} file upload, file size is no more than {size}.',
      uploadSize: 'The file size cannot exceed {size}',
      tmplNameReg: 'Please enter lowercase letters, numbers, or underscores',
      noLikePlsClick: 'Nothing suitable? Click {name}',
      broadcastSaveErr: 'There is an error in the user information in row {n}, please reupload.',
      broadcastSaveRepeat: 'The contact of row {n} already exists, please check and reupload.',
      broadcastSaveOverload: 'The number of users uploaded exceeds the upper limit of a single broadcast, please reupload.',
      broadcastDelTask: 'Tasks cannot be restored after deletion. Are you sure you wish to continue?',
      broadcastLimtNum: 'Current account {name}, the sending limit is {n}, if the limit is exceeded, the sending will fail.',
      broadcastDLTitle: 'Download this broadcast template',
      broadcastDLTip1: 'Please fill in the variable information for each user, and the unfilled part will be filled in with default values.',
      broadcastDLTip2: 'Only xlsx/csv type files samller than 1MB are supported to be uploaded. Up to 3000 contacts are supported in a single task.',
      broadcastReplies: 'After successful sending, number of contacts replied within 24 hours.',
      removeOptOut: 'Once this user is removed from the Opt-out list, the user will receive future broadcast messages sent by this WABA. Do you wish to continue?',
      optOutTerm: 'Note: Any added user will not receive broadcast messages from the WABA for 90 days.',
      batchTelUp: 'Support batch uploading, Line Break is needed between phone numbers<br>Sample:<br>+628122218888888<br>+628122217777777',
      avg_sessions_time: 'Average duration from time when user initiates the conversation to when session ends',
      avg_robot_time: 'Average duration of conversation handled by Bot ',
      avg_agent_time: 'Average duration from time when agent takes over the conversation to when session ends',
      avg_trans_time: 'Time taken when bot transfers conversation to agent',
      current_users_total: 'Active chats currently handled which are not yet closed',
      current_robot_wait: 'Chats currently waiting to be transferred to Bot ',
      current_agent_sessions: 'Chats currently handled by Agent',
      current_robot_sessions: 'Chats currently handled by Bot',
      current_agent_wait_sessions: 'Chats currently waiting to be transferred to Agent',
      downloadTip: 'Download exceeding 5,000 conversation records will be split into multiple files. Do you wish to continue?',
      selectUser:
        'Chatbot will only be activated when user clicks the template button or reply to the template. To be effective for the entire channel, please configure the chatbot under Chatbot Management.',
      assigned_agent: 'Only for transfers to AICC Business Inbox'
    },
    wbTmplTip: {
      header: "Add a title or choose which type of media you'll use for this header.",
      body: 'To add a custom variable, please add a variable in double curly brackets without a space.',
      body2: 'Example: {{name}}',
      footer: 'Add a short line of text to the bottom of your template message.',
      buttons: 'Create buttons that let customers respond to your message or take action.',
      buttonLimit: "Buttons can't have variables, newlines or emojis",
      variables: 'Make sure not to include any actual user or customer information, and provide only sample content in your examples.',
      sample: 'Sample content for {name}',
      del: 'After deleting the template, you cannot apply for a template with the same name within 30 days. Please confirm whether to delete it?',
      variableRepeat: 'Variable name cannot be repeat',
      optOutBtn: 'Unsubscribe option: If user clicks on the Opt-out button, the user will not receive any broadcast messages from the WABA for 90 days.',
      carousel1: 'Blank templates allow you to customize the header, body and footer of the message and add buttons.',
      carousel2: 'Carousel templates allow you to send a single text message accompanied by a set of up to 10 carousel cards in a horizontally scrollable view.',
      carouselSettings: 'All carousel cards have to follow consistent header, body and button formats',
      cardSettings: 'Carousel templates support up to 10 carousel cards. Cards must have a media header (image or video), body text, and at least one button with support up to 2 buttons. Buttons can be the same or a mix of quick reply buttons, phone number buttons, or URL buttons.',
      vtitle: 'Make sure not to include any actual user or customer information, and provide only sample content in your examples.',
      noV: 'None',
      type: "When 'Type' is selected,<br/> Template example will be auto-generated",
      addcard: 'Card not added | Card not completed'
    },
    insightsHistorical: {
      title1: 'Flow Distribution',
      title2: 'Flow Distribution By Day',
      title3: 'Intention Distribution',
      title4: 'Intention Distribution By Day',
      title5: 'Reason for Agent Transfer Distribution',
      title6: 'Reason for Agent Transfer Distribution By Day',
      title7: 'Reason for Agent Transfer Distribution',
      title8: 'Reason for Agent Transfer Distribution By Day',
      title9: 'Popular Topics',
      topic: 'Topic',
      count: 'Count'
    }
  },
  teamInbox: {
    // 新增
    all_chat: 'All',
    my_chat: 'Mine',
    manuanling: 'To be Assigned',
    broadcast: 'Broadcast',
    bot: 'Bot',
    closed: 'Closed',
    broadcastinfo: 'Broadcast Session',
    botinfo: 'Robot Session',
    broadcastType: 'Not Started',
    botType: 'Bot',
    manuanlingType: 'To be Assigned',
    manualedType: 'In Conversation with {user}',
    closedType: 'Closed',
    jiesu: 'End Session',
    jieg: 'Take over Session',
    userInfo: 'Customer Information',
    chatTitle: 'Agent Sessions',
    manualedAMType: 'Forward to',
    duihua: 'In Conversation',
    changeUser: 'Confirm to forward the session to:',
    tips: 'Tips',
    yes: 'Yes',
    no: 'No',
    noType: 'Displaying this type of message is not supported at this time.',
    start: '{name} started a new session.',
    close: '{name} closed the session.',
    take_over: '{name} took over the session.',
    hand_over: '{name} transferred the session to {toName}',
    msgSet: 'Message Setting'
  },
  security: {
    session: 'Session Timeout Management',
    defaultSession: 'Default Session Timeout',
    userInLogin: 'After logging in for ',
    autoLogout: 'the user will be logged out automatically. (Valid range: 1-24 hours)',
    idleSessionTimeout: 'Idle Session Timeout',
    userIn: 'No activity within ',
    noRun: 'then, the account will be logged out automatically. (Valid range: 5 minutes to 24 hours)',
    pl1: 'Please enter an integer between {num1} and {num2}.',
    accountLock: 'Account Lockout Management',
    maxError: 'Maximum Login Failures before Account Lockout',
    lockTime: 'Lockout Duration',
    lockTipBase: '(After the account is locked, it will automatically log out, and login attempts are disabled during the lockout period.)',
    counter: 'Counter Reset Interval',
    counterTip: '(After this time interval, the login failure counter will be reset, and counting will start from 0.)',
    couMag: 'Concurrent Login Management',
    oneAccount: 'A single account can be logged in simultaneously on',
    bro: ' devices/browsers.',
    forMag: 'Account Disable Management',
    ifMag: 'If an account has not been logged in within the validity period, further login attempts will be disabled.',
    nearMag: 'Last Login Notification',
    loginSuccess: 'When logging in successfully, last login time will be displayed.',
    accountTrue: 'Login Expiration Timeout',
    saveTip: 'Modifying the account security settings will affect the account behavior and all its sub-accounts. Are you sure you want to proceed with the modification?',
    loginLockTip: 'Incorrect username or password. If entered incorrectly {errorNum} more times, the user will be locked out for {errorMin} minutes.',
    forTip: 'This user account has been disabled. Please contact the administrator or our support team for assistance.',
    lockTip: 'The current user account is locked. Please retry after {errorMin} minutes.',
    loginSuccess2: 'Successful Login ',
    last: 'Last Login Information',
    moreTip: 'Sorry,  the access frequency has exceeded the limit. Please try again later.',
    lockTip2: 'Your account has been locked. Please retry.',
    userStatus: 'Account Status',
    visitStatus: 'Access Status'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js